import {
  useEffect,
  useRef,
  useState,
} from 'react';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { useAnimation } from "react-animatable";
import {
  Score,
  DuelText,
  DuelSettingsButton,
} from 'MonadomCoreUI';
import {
  ForDevelopment
} from './dev/developmentUI';
import {
  Sound,
} from './UtilComponents';
import {
  ensureUnlockAudio,
} from './audioPlayer';
import {
  useGlobalStateSelector,
  words,
  collectibleWordTextKeys,
} from './globalState';
import {
  handleClickLeaveDuel,
  handleClickEndDuel,
  cleanUpDuelInState,
  sendChallengeDuel,
  handleClickSummonMonster,
  handleClickCostMonster,
  handleClickSelectCemeteryCard,
  handleClickCastMagic,
  handleClickCancelMagic,
  handleClickNext,
  buildCollectibleWordAudioUrls,
} from './duel';
import {
  copyDuelHistoryStoryToClipboard,
  downloadDuelHistoryStoryImage,
  copyDuelHistoryKnightBoxesToClipboard,
  downloadDuelHistoryKnightBoxesImage,
} from 'monadomCore';
import {
  otherSide,
  sideColor,
  borderColor,
  getSelectStatusType,
  getRoute,
  // magicNarration,
  recoverTextField,
  getCardStatus,
  getCardStatusTmp,
} from 'utils/utilsKom';
import {
  sendLog,
  upsertCompositeRecordInIndexedDb,
} from 'utils';
import {
  devLog,
} from './dev/development';
import roseRed from './roseRed.png';
import roseBlue from './roseBlue.png';
import iconReplay from './live_tv_FILL0_wght400_GRAD0_opsz24.svg';
import iconHeaderFooter from './ad_units_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import iconShare from './share_FILL0_wght400_GRAD0_opsz48.svg';
import iconCopy from './content_copy_FILL0_wght400_GRAD0_opsz48.svg';
import iconRecovery from 'image/local_hospital_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconDownload from './image/download_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import monaFavicon from './monaFavicon.png';
import emblemRed from './emblemRed.png';
import emblemBlue from './emblemBlue.png';
import imageMagicRed from './magicRed.png';
import imageMagicBlue from './magicBlue.png';
import imageCost from './cost.png';
import imageCostToBeExcludedFromCemetery from './costToBeExcludedFromCemetery.png';
import imageTarget from './target.png';
import imageCemetery from './cemetery.png';
import imageAnotherDimension from './anotherDimension.png';
import imageHiddenMagic from './hiddenMagic.png';
import imageBulletHole01 from './bulletHole01.png';
import logoWin from './logoWin.png';
import logoLose from './logoLose.png';
import logoTheEnd from './logoTheEnd.png';
import logoDraw from './logoDraw.png';
import voiceKatta01 from './sound/01_katta01.mp3';
import voiceKatta02 from './sound/01_katta02.mp3';
import voiceMaketa01 from './sound/05_maketa01.mp3';
import voiceMaketa02 from './sound/05_maketa02.mp3';

const soundMap = {
  'katta01': voiceKatta01,
  'katta02': voiceKatta02,
  'maketa01': voiceMaketa01,
  'maketa02': voiceMaketa02,
};

// DUEL
function Duel(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const side = state.duel.basicInformation?.side;
  const gameMode = props.gameMode;
  const difficultyMode = props.difficultyMode;
  const textAreaRef = useRef(null);

  if (state.active.addressMain === undefined || state.session[state.active.addressMain]?.sessionId === undefined || state.session[state.active.addressMain]?.expirationOfSession < Date.now()) {
    return <PleaseLogin />;
  }

  let webSocketInterface;

  if (state.active.addressMain !== undefined && state.session[state.active.addressMain]?.sessionId !== undefined) {
    webSocketInterface = <WebSocketInterface gameMode={gameMode} difficultyMode={difficultyMode} />;
  }
  else {
    webSocketInterface = null;
  }

  let otherSide;
  // let sideColor;
  // let otherSideColor;
  let sideClass;
  let otherSideClass;
  let myAlternative;
  let opponentAlternative;
  let myAlternativeMagic;
  let opponentAlternativeMagic;
  let myPoint;
  let opponentPoint;
  let myRose;
  let opponentRose;
  let myUserName;
  let opponentUserName;

  if (side === 'A') {
    //sideColor = '赤';
    otherSide = 'B';
    // otherSideColor = '青';
    sideClass = 'classA';
    otherSideClass = 'classB';
    myAlternative = 'emblemRed';
    opponentAlternative = 'emblemBlue';
    myAlternativeMagic = 'imageMagicRed';
    opponentAlternativeMagic = 'imageMagicBlue';
    myPoint = state.duel.pointA;
    opponentPoint = state.duel.pointB;
    myRose = roseRed;
    opponentRose = roseBlue;
    myUserName = state.duel.basicInformation?.duelistAUserName;
    opponentUserName = state.duel.basicInformation?.duelistBUserName;
  }
  else if (side === 'B') {
    // sideColor = '青';
    otherSide = 'A';
    // otherSideColor = '赤';
    sideClass = 'classB';
    otherSideClass = 'classA';
    myAlternative = 'emblemBlue';
    opponentAlternative = 'emblemRed';
    myAlternativeMagic = 'imageMagicBlue';
    opponentAlternativeMagic = 'imageMagicRed';
    myPoint = state.duel.pointB;
    opponentPoint = state.duel.pointA;
    myRose = roseBlue;
    opponentRose = roseRed;
    myUserName = state.duel.basicInformation?.duelistBUserName;
    opponentUserName = state.duel.basicInformation?.duelistAUserName;
  }
  else {
    otherSide = undefined;
  }

  // デッキ

  let myDeck;
  let opponentDeck;
  let myDeckSP;
  let opponentDeckSP;

  if (state.duel.basicInformation !== undefined) {
    if (side === 'A') {
      myDeck =
      <div className='boxDeck classBackGroundA paddingBottom1' >
        <div className='deckRibbonRed'>
          { myUserName + words.sDeck[state.language] }
          {/* words.yourDeck[state.language] */}
        </div>
        <div className='flexRow justifyContentCenter widthMax'>
          <DeckOnDuel deck={state.duel.basicInformation?.duelistADeck} sideRelative='self' />
        </div>
      </div>;

      opponentDeck =
      <div className='boxDeck classBackGroundB paddingBottom1' >
        <div className='deckRibbonBlue'>
          { opponentUserName !== undefined ? opponentUserName + words.sDeck[state.language] : null }
          {/* words.opponentsDeck[state.language] */}
        </div>
        <div className='flexRow justifyContentCenter widthMax'>
          <DeckOnDuel deck={state.duel.basicInformation?.duelistBDeck} sideRelative='other' />
        </div>
      </div>;

      myDeckSP =
      <button className='flexColumn justifyContentSpaceAround alignItemsCenter pointerEventsAuto button2 widthDiv3 heightMin4 marginSide0p7 font0p7' disabled={props.disabled ? true : false}
        onClick={ () => {
          const body = {
            deck: state.duel.basicInformation?.duelistADeck,
            sideRelative: 'self',
          }

          const popup = { type: 'deckOnDuelSP', body: body };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });

          dispatch({ type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'invisible' });
        }}
      >
        <div>
          { myUserName }
        </div>
        <div>
          { words.sDeck[state.language] }
        </div>
      </button>

      opponentDeckSP =
      <button className='flexColumn justifyContentSpaceAround alignItemsCenter pointerEventsAuto button2 widthDiv3 heightMin4 marginSide0p7 font0p7' disabled={props.disabled ? true : false}
        onClick={ () => {
          const body = {
            deck: state.duel.basicInformation?.duelistBDeck,
            sideRelative: 'other',
          }

          const popup = { type: 'deckOnDuelSP', body: body };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });

          dispatch({ type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'invisible' });
        }}
      >
        <div>
          { opponentUserName !== undefined ? opponentUserName : null }
        </div>
        <div>
          { opponentUserName !== undefined ? words.sDeck[state.language] : null }
        </div>
      </button>
    }
    else { // B
      myDeck =
      <div className='boxDeck classBackGroundB paddingBottom1' >
        <div className='deckRibbonBlue'>
          { myUserName + words.sDeck[state.language] }
          {/* words.yourDeck[state.language] */}
        </div>
        <div className='flexRow justifyContentCenter widthMax'>
          <DeckOnDuel deck={state.duel.basicInformation?.duelistBDeck} sideRelative='self' />
        </div>
      </div>;

      opponentDeck =
      <div className='boxDeck classBackGroundA paddingBottom1' >
        <div className='deckRibbonRed'>
          { opponentUserName + words.sDeck[state.language] }
          {/* words.opponentsDeck[state.language] */}
        </div>
        <div className='flexRow justifyContentCenter widthMax'>
          <DeckOnDuel deck={state.duel.basicInformation?.duelistADeck} sideRelative='other' />
        </div>
      </div>;

      myDeckSP =
      <button className='flexColumn justifyContentSpaceAround alignItemsCenter pointerEventsAuto button2 widthDiv3 heightMin4 marginSide0p7 font0p7' disabled={props.disabled ? true : false}
        onClick={ () => {
          const body = {
            deck: state.duel.basicInformation?.duelistBDeck,
            sideRelative: 'self',
          }

          const popup = { type: 'deckOnDuelSP', body: body };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });

          dispatch({ type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'invisible' });
        }}
      >
        <div>
          { myUserName }
        </div>
        <div>
          { words.sDeck[state.language] }
        </div>
      </button>

      opponentDeckSP =
      <button className='flexColumn justifyContentSpaceAround alignItemsCenter pointerEventsAuto button2 widthDiv3 heightMin4 marginSide0p7 font0p7' disabled={props.disabled ? true : false}
        onClick={ () => {
          const body = {
            deck: state.duel.basicInformation?.duelistADeck,
            sideRelative: 'other',
          }

          const popup = { type: 'deckOnDuelSP', body: body };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });

          dispatch({ type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'invisible' });
        }}
      >
        <div>
          { opponentUserName !== undefined ? opponentUserName : null }
        </div>
        <div>
          { opponentUserName !== undefined ? words.sDeck[state.language] : null }
        </div>
      </button>
    }
  }
  else {
    myDeck = null;

    opponentDeck = null;
  }

  // 召喚モンスター

  let myMonster;
  let opponentMonster;

  myMonster = <CardOnDuel
    asset={ state.duel.monstersInformation?.[side]?.asset }
    index={state.duel.monstersIndex?.[side]}
    side={side} alternative={myAlternative}
    position='field'
   />;

  opponentMonster = <CardOnDuel
    asset={ state.duel.monstersInformation?.[otherSide]?.asset }
    index={state.duel.monstersIndex?.[otherSide]}
    side={otherSide}
    alternative={opponentAlternative}
    position='field'
  />;

  // 詠唱魔法

  let myMagic;
  let opponentMagic;

  myMagic = <CardOnDuel
    asset={ state.duel.magics?.[side]?.[0]?.asset }
    index={ state.duel.magics?.[side]?.[0]?.index }
    side={side}
    alternative={myAlternativeMagic}
    styleSize='small'
    position='cast'
   />;

  opponentMagic = <CardOnDuel
    asset={ state.duel.magics?.[otherSide]?.[0]?.asset }
    index={ state.duel.magics?.[otherSide]?.[0]?.index }
    side={otherSide}
    alternative={opponentAlternativeMagic}
    styleSize='small'
    position='cast'
  />;


  // タイム
  let time;

  if (state.duel.status === 'timeUp') {
    if (state.duel.duelWinner === side) {
      time = words.timeupAndYouWin[state.language];
    }
    else if (state.duel.duelWinner === otherSide) {
      time = words.timeupAndYouLose[state.language];
    }
    else { //draw
      time = words.timeupAndDraw[state.language];
    }
  }
  else if (state.duel.status === 'leave') {
    if (state.duel.duelWinner === side) {
      time = words.opponentHasLeftTheField[state.language];
    }
    else { // lose デュエル中ログイン
      time = words.youHasLoggedInOnAnotherScreenYouLose[state.language];
    }
  }
  else if (state.duel.status === 'leaveWithoutOpponentComming') { // 対人戦待ち中ログイン
    time = words.youHasLoggedInOnAnotherScreen[state.language];
  }
  else if (state.duel.myStatus === 'waitingToSummon' || state.duel.myStatus === 'uncomfirmed') {
    time = Math.floor((state.duel.timeOutTime - state.clock) / 1000);
  }
  else if (state.duel.status === 'waitingInRoom') {
    time = words.waitingForYourOpponent[state.language];
  }
  else {
    time = null;
  }

  // 召喚エフェクト

  let mySummonEffect;
  let opponentSummonEffect;
  let myBlind;
  let opponentBlind;

  if (state.duel.action === 'summon') {
    mySummonEffect = <SummonEffect />;
    myBlind = <Blind direction='L' />;
  }

  if (state.duel.actionOpponent === 'summon') {
    opponentSummonEffect = <SummonEffect />;
    opponentBlind = <Blind direction='R' />;
  }

  // 決着エフェクト
  let myBattleUpEffect;
  let opponentBattleUpEffect;
  let duelUpEffect;

  if (state.duel.status === 'battleUp' || state.duel.status === 'duelUp') {
    if (state.duel.winner === side) {
      myBattleUpEffect = <YouWin />;
      opponentBattleUpEffect = <YouLose />;
    }
    else if (state.duel.winner === otherSide) {
      myBattleUpEffect = <YouLose />;
      opponentBattleUpEffect = <YouWin />;
    }
    else { // draw
      myBattleUpEffect = <Draw />;
      opponentBattleUpEffect = <Draw />;
    }

    if (state.duel.status === 'duelUp') {
      duelUpEffect = <DuelUp />;
    }
  }
  else {
    myBattleUpEffect = null;
    opponentBattleUpEffect = null;
    duelUpEffect = null;
  }

  // 魔法エフェクト
  let magicEffect;

  if (state.duel.status === 'magicPhase') {
    if (state.duel.magics.A[0] !== undefined || state.duel.magics.B[0] !== undefined) {
      magicEffect = <Flash />;
    }
    if (state.duel.magics.A[0] !== undefined) {
      magicEffect = <Flash />;
    }
    if (state.duel.magics.B[0] !== undefined) {
      magicEffect = <Flash />;
    }
  }

  // ナイトボックスエフェクト
  let myKnightBoxEffect;
  let opponentKnightBoxEffect;
  let myKnightBoxEffectSP;
  let opponentKnightBoxEffectSP;

  if (state.duel.knightBoxEffect?.[side] === 'bulletHoles') {
    myKnightBoxEffect = <BulletHoles side={side} />;
    myKnightBoxEffectSP = <BulletHoles side={side} device='SP' />;
  }

  if (state.duel.knightBoxEffect?.[otherSide] === 'bulletHoles') {
    opponentKnightBoxEffect = <BulletHoles side={otherSide} />;
    opponentKnightBoxEffectSP = <BulletHoles side={otherSide} device='SP' />;
  }

  // KNIGHT BOX
  // ナイトボックス

  let knightBox = {};
  let knightBoxSP = {};

  if (difficultyMode === 'simple') {
    knightBox.mySide =
    <div className={'flexColumn margin0p5 duelBattlePanelL ' + sideClass} >
      <div className='heightMin1p3 margin0p5' >
        { myUserName }
      </div>
      <div className='knightBox '>
        { myMonster }
        { myBlind }
        { mySummonEffect }
        { myBattleUpEffect }
        { myKnightBoxEffect }
      </div>
    </div>;

    knightBox.opponentSide =
    <div className={'flexColumn margin0p5 duelBattlePanelR ' + otherSideClass}>
      <div className='heightMin1p3 margin0p5' >
        { opponentUserName }
      </div>
      <div className='knightBox ' >
        { opponentMonster }
        { opponentBlind }
        { opponentSummonEffect }
        { opponentBattleUpEffect }
        { opponentKnightBoxEffect }
      </div>
    </div>;

    knightBoxSP.mySide =
    <div className={'knightBox widthKnightBoxSP heightKnightBoxSP duelBattlePanelL ' + sideClass} >
      <div className='heightMin1p3 font0p7' >
        { myUserName }
      </div>
      { myMonster }
      { myBlind }
      { mySummonEffect }
      { myBattleUpEffect }
      { myKnightBoxEffectSP }
    </div>;

    knightBoxSP.opponentSide =
    <div className={'knightBox widthKnightBoxSP heightKnightBoxSP duelBattlePanelR ' + otherSideClass} >
      <div className='heightMin1p3 font0p7' >
        { opponentUserName }
      </div>
      { opponentMonster }
      { opponentBlind }
      { opponentSummonEffect }
      { opponentBattleUpEffect }
      { opponentKnightBoxEffectSP }
    </div>;
  }
  else { // advanced
    knightBox.mySide =
    <div className={'flexColumn margin0p5 duelBattlePanelL ' + sideClass} >
      <div className='heightMin1p3 margin0p5' >
        { myUserName }
      </div>
      <div className='flexRow justifyContentCenter ' >
        <div className='flexColumn justifyContentCenter alignItemsCenter width3 marginTop0p5 padding0p5 ' >
          <MaginaGauge side={side} sideRelative='self' />
          <div className='margin0p5' >
            <MaginaPointApplied side={side} sideRelative='self' />
          </div>
        </div>
        <div className='flexColumn justifyContentFlexStart alignItemsCenter' >
          <div className='flexRow justifyContentCenter ' >
            <div className='flexColumn justifyContentFlexStart alignItemsCenter width11 marginTop0p5 padding0p5 ' >
              <MaginaPoint side={side} baseClass='padding0p5' initiativeClass={'borderFat borderRadius0p5 ' + borderColor(side)} />
              <div className='flexColumn justifyContentFlexStart alignItemsCenter marginTop1'> 
                { myMagic }
                <TargetIndication side={side} />
                <div className='marginTop0p5'> 
                  {/* cancelMagic */}
                  <CancelMagic />
                </div> 
              </div> 
            </div>
          </div>
          <div className='margin0p5 ' >
            <MagicInstruction fontSize='0.9em' />
          </div>
        </div>
        <div className='knightBox '>
          { myMonster }
          { myBlind }
          { mySummonEffect }
          { myBattleUpEffect }
          { myKnightBoxEffect }
        </div>
      </div>
    </div>;

    knightBox.opponentSide =
    <div className={'flexColumn margin0p5 duelBattlePanelR ' + otherSideClass}>
      <div className='heightMin1p3 margin0p5' >
        { opponentUserName }
      </div>
      <div className='flexRow justifyContentCenter ' >
        <div className='knightBox ' >
          { opponentMonster }
          { opponentBlind }
          { opponentSummonEffect }
          { opponentBattleUpEffect }
          { opponentKnightBoxEffect }
        </div>
        <div className='flexColumn justifyContentFlexStart alignItemsCenter width11 marginTop0p5 padding0p5 ' >
          <MaginaPoint side={otherSide} baseClass='padding0p5' initiativeClass={'borderFat borderRadius0p5 ' + borderColor(otherSide)} />
          <div className='flexColumn justifyContentFlexStart alignItemsCenter marginTop1'> 
            { opponentMagic }
            <TargetIndication side={otherSide} />
          </div> 
        </div>
        <div className='flexColumn justifyContentCenter alignItemsCenter width3 marginTop0p5 padding0p5 ' >
          <MaginaGauge side={otherSide} sideRelative='other' />
          <div className='margin0p5' >
            <MaginaPointApplied side={otherSide} sideRelative='other' />
          </div>
        </div>
      </div>
    </div>;

    knightBoxSP.mySide =
    <div className={'knightBox widthKnightBoxSP heightKnightBoxSP duelBattlePanelL ' + sideClass} >
      <div className='heightMin1p3 font0p7' >
        { myUserName }
      </div>
      { myMonster }
      { myBlind }
      { mySummonEffect }
      { myBattleUpEffect }
      { myKnightBoxEffectSP }
      <div className='flexRow justifyContentFlexStart alignItemsCenter margin0p5'> 
        { myMagic }
        <div className='flexColumn justifyContentFlexStart alignItemsCenter '>
          <MaginaPoint side={side} baseClass='padding0p3 font0p7' initiativeClass={'borderFat borderRadius0p5 ' + borderColor(side)} />
          <MaginaPointApplied side={side} sideRelative='self' device='SP' />
          <TargetIndication side={side} textClass='font0p5' />
        </div>
      </div> 
    </div>;

    knightBoxSP.opponentSide =
    <div className={'knightBox widthKnightBoxSP heightKnightBoxSP duelBattlePanelR ' + otherSideClass} >
      <div className='heightMin1p3 font0p7' >
        { opponentUserName }
      </div>
      { opponentMonster }
      { opponentBlind }
      { opponentSummonEffect }
      { opponentBattleUpEffect }
      { opponentKnightBoxEffectSP }
      <div className='flexRow justifyContentFlexStart alignItemsCenter margin0p5'> 
        { opponentMagic }
        <div className='flexColumn justifyContentFlexStart alignItemsCenter '>
          <MaginaPoint side={otherSide} baseClass='padding0p3 font0p7' initiativeClass={'borderFat borderRadius0p5 ' + borderColor(otherSide)} />
          <MaginaPointApplied side={otherSide} sideRelative='other' device='SP' />
          <TargetIndication side={otherSide}  textClass='font0p5' />
        </div>
      </div> 
    </div>;
  }

  // バトルアップボイス

  let battleUpVoice;
  let battleUpVoiceAudioUrl;
  let battleResultRound;
  let collectibleWordAudioUrls = [];

  if (state.duel.status === 'battleUp') {
    battleResultRound = state.duel.round - 1;
  }
  else {
    battleResultRound = state.duel.round;
  }

  const battleResult = state.duel.result[battleResultRound]?.soundEffects?.[side]?.battleResult;
  if (battleResult?.effectName !== undefined) {
    battleUpVoiceAudioUrl = soundMap[battleResult.effectName];
  }

  if (state.duel.collectibleWordSoundEffectNamesInBattle.length >= 1) {
    collectibleWordAudioUrls = buildCollectibleWordAudioUrls({
      collectibleWordSoundHostPath: state.config.clientParameters.collectibleWordSoundHostPath,
      collectibleWordSoundSetting: state.localSettingsCommon.collectibleWordSound,
      collectibleWordSoundEffectNamesInBattle: state.duel.collectibleWordSoundEffectNamesInBattle,
    });
  }

  if (state.duel.status === 'battleUp' || state.duel.status === 'duelUp') {
    battleUpVoice = <Sound audioUrls={[battleUpVoiceAudioUrl, ...collectibleWordAudioUrls]} />;
  }
  else {
    // eslint-disable-next-line no-unused-vars
    battleUpVoice = null;
  }

  // コレクションワード獲得表示

  let collectibleWordShowcase = null;

  if (state.duel.status === 'battleUp' || state.duel.status === 'duelUp') {
    const collectibleWords = state.duel.result[battleResultRound]?.collectibleWords;

    if (collectibleWords !== undefined) {
      const seenWords = new Set();
      const collectibleWordFaces = collectibleWordTextKeys
        .flatMap(textKey => collectibleWords[textKey])
        .filter(({ word }) => {
          if (seenWords.has(word)) {
            return false;
          }

          seenWords.add(word);
          return true;
        })
        .map(({ face }) => face);

      if (collectibleWordFaces.length >= 1) {
        collectibleWordShowcase =
          <CollectibleWordShowcase key={battleResultRound} faces={collectibleWordFaces} />;
      }
    }
  }

  // 履歴画像シェアボタン

  let duelHistoryShareButton;
  let completedDuelHistoryRound = -1;

  for (let roundIndex = state.duel.result.length - 1; roundIndex >= 0; roundIndex -= 1) {
    const result = state.duel.result[roundIndex];

    if (result?.winner !== undefined && result?.monsters !== undefined && result?.liveText !== undefined && result?.field !== undefined) {
      completedDuelHistoryRound = roundIndex;
      break;
    }
  }

  const completedDuelHistoryThisRound = completedDuelHistoryRound >= 0
    ? state.duel.result[completedDuelHistoryRound]
    : undefined;
  const duelHistoryShareRecord = state.duel.basicInformation !== undefined
    ? {
      ...state.duel.basicInformation,
      difficultyMode: state.duel.basicInformation.difficultyMode ?? difficultyMode,
      result: state.duel.result,
      round: completedDuelHistoryRound,
      pointA: state.duel.pointA,
      pointB: state.duel.pointB,
      duelWinner: state.duel.duelWinner,
    }
    : undefined;
  const canShareDuelHistoryImages = (
    [
      'battleUp',
      'duelUp',
      'timeUp',
      'timeUpAfterDuelUp',
      'leave',
      'leaveAfterDuelUp',
    ].includes(state.duel.status) &&
    completedDuelHistoryThisRound !== undefined &&
    duelHistoryShareRecord !== undefined
  );

  if (canShareDuelHistoryImages) {
    const duelHistorySharePopupLayer = 0;

    duelHistoryShareButton =
    <button className='button1'
      onClick={ () => {
        const popup = { type: 'generalItems', body: <Share record={duelHistoryShareRecord} /> };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', duelHistorySharePopupLayer], value: popup });
      }}
    >
      <img className='size2x2' src={iconShare} alt='share' />
    </button>;
  }
  else {
    duelHistoryShareButton = null;
  }

  // 履歴ボタン

  let historyButton;

  const queryParameter = `?roomid=${state.duel.basicInformation?.roomId}&duelno=${state.duel.basicInformation?.duelNo}`;

  if (state.duel.status === 'duelUp' || state.duel.status === 'timeUp' || state.duel.status === 'timeUpAfterDuelUp' || state.duel.status === 'leave' || state.duel.status === 'leaveAfterDuelUp') {
    historyButton =
    <button className='button1'
      onClick={ () => {
        navigate((process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelhistorydetail' : '/duelhistorydetail') + queryParameter);
        handleClickEndDuel(state, dispatch, navigate);
      }}
    >
      <img className='size2x2' src={iconReplay} alt='replay' />
    </button>;
  }
  else {
    historyButton = null;
  }

  // バックボタン

  let backButton;
  let backButtonSp;

  if (state.duel.status === 'duelUp' || state.duel.status === 'timeUp' || state.duel.status === 'timeUpAfterDuelUp' || state.duel.status === 'leave' || state.duel.status === 'leaveAfterDuelUp') {
    backButton =
    <button className='button2'
      onClick={ () => {
        handleClickEndDuel(state, dispatch, navigate);
      }}
    >
      { words.back[state.language] }
    </button>;

    backButtonSp =
    <button className='button2' onClick={ () => handleClickEndDuel(state, dispatch, navigate) }>
      { words.back[state.language] }
    </button>;
  }
  else if (state.duel.status !== undefined) {
    backButton =
    <button className='button2' onClick={ () => handleClickLeaveDuel(state, dispatch, navigate) }>
      { words.leaveDuel[state.language] }
    </button>;

    backButtonSp =
    <button className='button2' onClick={ () => handleClickLeaveDuel(state, dispatch, navigate) }>
      { words.leaveDuel[state.language] }
    </button>;
  }
  else {
    backButton =
    <button className='button2Dummy ' disabled={true} >
    </button>;

    backButtonSp =
    <button className='button2Dummy ' disabled={true} >
    </button>;
  }

  // -- リカバリボタン

  let recoverDuelButton;

  if ([
    'duelUp',
    'timeUp',
    'timeUpAfterDuelUp',
    'timeUpWithoutOpponentComming',
    'leave',
    'leaveAfterDuelUp',
    'leaveWithoutOpponentComming',
  ].includes(state.duel.status)) {
    recoverDuelButton = null;
  }
  else {
    recoverDuelButton =
    <button className='button1'
      onClick={ () => {
        ensureUnlockAudio();

        sendChallengeDuel({
          webSocket: state.webSocketContainer.webSocket,
          addressMain: state.active.addressMain,
          sessionId: state.session[state.active.addressMain].sessionId,
          gameMode: gameMode,
          difficultyMode: difficultyMode,
          designatedAddressesCsv: state.challengeDuel.designatedAddressesCsv,
          gameOption: state.challengeDuel.gameOption,
          recoveryOnly: true,
        });
      }}
    >
      <img className='size2x2' src={iconRecovery} alt='recovery' />
    </button>;
  }


  // -- ヘッダ・フッタポジション切替ボタン

  const headerFooterPositionButton =
  <button className='button1'
    onClick={ () => {
      // state.webSocketContainer.webSocket?.close(3000, 'test');
      // state.webSocketContainer.webSocket?.reconnect();

      if (state.headerFooterPosition === 'fixed') {
        dispatch({ type: 'setState', key: 'headerFooterPosition', value: 'relative' });
      }
      else { // relative
        dispatch({ type: 'setState', key: 'headerFooterPosition', value: 'fixed' });
      }
    }}
  >
    <img className='size2x2' src={iconHeaderFooter} alt='' />
  </button>;

  // ヘッダ・フッタ

  let headerFixed;
  let headerRelative;
  let footerFixed;
  let footerRelative;
  let headerFixedPc;
  let headerRelativePc;

  const headerCore =
  <div className='flexColumn alignItemsCenter widthMax '>
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax '>
      <div className='flexRow justifyContentFlexEnd alignItemsCenter flexGrow1 '>
        <div className='font2'>
          { time }
        </div>
      </div>
      <div className='flexRow justifyContentFlexEnd alignItemsCenter'>
        <div className='marginSide0p5'>
          { historyButton }
        </div>
        <div className='marginSide0p5'>
          { duelHistoryShareButton }
        </div>
        { backButtonSp }
      </div>
    </div>
    <div className='flexRow justifyContentCenter widthMax'>
      <div className='flexRow justifyContentFlexEnd alignItemsCenter width40PC marginSide1 '>
        <Score src={myRose} point={myPoint} />
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter width40PC marginSide1 '>
        <Score src={opponentRose} point={opponentPoint} />
      </div>
    </div>
  </div>;

  const footerCore =
  <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax '>
    { myDeckSP }
    <NextButton />
    { opponentDeckSP }
  </div>;

  const headerCorePc =
  <div className='flexRow justifyContentSpaceBetween width121 maxWidthMax '>
    <div className='flexRow justifyContentFlexStart widthMin10 '>
      <NextButton />
    </div>
    <div className='flexRow justifyContentCenter'>
      <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMin10 marginSide1 '>
        <Score src={myRose} point={myPoint} />
      </div>
      <div className='flexRow justifyContentCenter alignItemsCenter font2 '>
        { time }
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter widthMin10 marginSide1 '>
        <Score src={opponentRose} point={opponentPoint} />
      </div>
    </div>
    <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMin10 '>
      <DuelSettingsButton />
      { recoverDuelButton }
      { headerFooterPositionButton }
      { duelHistoryShareButton }
      <div className='marginSide0p5'>
        { historyButton }
      </div>
      { backButton }
    </div>
  </div>;

  if (state.headerFooterPosition === 'fixed') {
    headerFixed =
    <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
      { headerCore }
    </div>;

    footerFixed =
    <div className='z200FixedBottom widthMax pointerEventsNone '>
      { footerCore }
    </div>;

    headerFixedPc =
    <div className='z200FixedZero widthMax backgroundColorWhiteTransparent flexRow justifyContentCenter '>
      { headerCorePc }
    </div>;

    headerRelative =
    <div className='widthMax height11 ' >
    </div>;

    footerRelative =
    <div className='widthMax height5 ' >
    </div>;

    headerRelativePc =
    <div className='widthMax height6 ' >
    </div>;
  }
  else { // relative
    headerRelative = headerCore;
    footerRelative = footerCore;
    headerRelativePc = headerCorePc;
  }

  // メインスクリーン

  let mainScreen;

  if (state.duel.basicInformation !== undefined) {
    mainScreen =
    <div >
      {/* PC */}
      <div className="visibleHuge flexColumn alignItemsCenter duelMainScreenBackground">
        <div className="relative ">
          { headerRelativePc }
          <div className='flexColumn alignItemsCenter ' >
            { opponentDeck }
            <div className='flexRow duelField justifyContentSpaceAround alignItemsStretch'>
              { knightBox.mySide }
              <div className='duelTextBattlePanel'>
                <DuelText />
                { duelUpEffect }
              </div>
              { knightBox.opponentSide }
            </div>
            <div className='flexRow ' >
              <div className='marginSide1 ' >
                { myDeck }
              </div>
              <div className='marginSide1 ' >
                { <SelectControlButton layer={0} /> }
              </div>
            </div>
          </div>
        </div>
        { headerFixedPc }
        {/* battleUpVoice */}
        {/* development */}
        { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
      </div>
      {/* TABLET */}
      <div className="visibleLarge flexColumn alignItemsCenter duelMainScreenBackground">
        <div className="relative ">
          <div className='flexColumn alignItemsCenter ' >
            { opponentDeck }
            <div className='flexRow justifyContentSpaceBetween widthMax '>
              <div className='flexRow justifyContentFlexStart widthMin10 '>
                {/* nextButton */}
                <NextButton />
              </div>
              <div className='flexRow justifyContentCenter'>
                <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMin10 marginSide1 '>
                  <Score src={myRose} point={myPoint} />
                </div>
                <div className='flexRow justifyContentCenter alignItemsCenter font2 '>
                  { time }
                </div>
                <div className='flexRow justifyContentFlexStart alignItemsCenter widthMin10 marginSide1 '>
                  <Score src={opponentRose} point={opponentPoint} />
                </div>
              </div>
              <div className='flexRow justifyContentFlexEnd widthMin10 '>
                <DuelSettingsButton />
                { duelHistoryShareButton }
                <div className='marginSide0p5'>
                  { historyButton }
                </div>
                { backButton }
              </div>
            </div>
            <div className='duelField flexColumn justifyContentFlexStart alignItemsCenter'>
              <div className='flexRow justifyContentSpaceAround alignItemsCenter' >
                { knightBox.mySide }
                { knightBox.opponentSide }
              </div>
              <DuelText fontSizeClass='font1p5' />
              { duelUpEffect }
            </div>
            <div className='flexRow ' >
              <div className='marginSide1 ' >
                { myDeck }
              </div>
              <div className='marginSide1 ' >
                { <SelectControlButton layer={0} /> }
              </div>
            </div>
          </div>
        </div>
        {/* battleUpVoice */}
        {/* development */}
        {/* process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null */}
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess relative widthMax overflowXHidden duelMainScreenBackground ">
        <div className="flexColumn alignItemsCenter widthMax ">
          { headerRelative }
          <div className='duelField duelFieldSP flexColumn alignItemsCenter'>
            <div className='flexRow justifyContentSpaceAround alignItemsFlexStart widthMax'>
              { knightBoxSP.mySide }
              { knightBoxSP.opponentSide }
            </div>
            <div >
              <DuelText fontSizeClass='' />
              { duelUpEffect }
            </div>
          </div>
          <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMax'>
            <div className='pointerEventsAuto flexRow alignItemsCenter '>
              <DuelSettingsButton />
              { recoverDuelButton }
              { headerFooterPositionButton }
            </div>
          </div>
          { footerRelative }
        </div>
        { headerFixed }
        { footerFixed }
        {/* battleUpVoice */}
      </div>
    </div>;
  }
  else {
    mainScreen = <NowLoading />;
  }


  return (
    <div>
      { webSocketInterface }
      <Clock />
      { mainScreen }
      { battleUpVoice }
      { collectibleWordShowcase }
      {/* magicEffect */}
      { magicEffect }
      <textarea ref={textAreaRef} style={{ position: 'absolute', left: '-9999px' }} ></textarea>
    </div>
  );
}

function DuelSettingsPopup({ popupLayer }) {
  const language = useGlobalStateSelector(({ state }) => state.language);
  const appSoundSwitchSettingInState = useGlobalStateSelector(({ state }) => state.localSettingsCommon.appSoundSwitch);
  const collectibleWordSoundSettingInState = useGlobalStateSelector(({ state }) => state.localSettingsCommon.collectibleWordSound);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const [appSoundSwitchSetting, setAppSoundSwitchSetting] = useState(appSoundSwitchSettingInState);
  const [collectibleWordSoundSetting, setCollectibleWordSoundSetting] = useState(collectibleWordSoundSettingInState);

  const closePopup = () => {
    dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
  };

  const handleClickOk = async () => {
    await Promise.all([
      upsertCompositeRecordInIndexedDb({
        dbName: 'knightsOfMonadom',
        storeName: 'localSettingsCommon',
        keyFields: ['id'],
        record: {
          id: 'appSoundSwitch',
          value: appSoundSwitchSetting,
        },
      }),
      upsertCompositeRecordInIndexedDb({
        dbName: 'knightsOfMonadom',
        storeName: 'localSettingsCommon',
        keyFields: ['id'],
        record: {
          id: 'collectibleWordSound',
          value: collectibleWordSoundSetting,
        },
      }),
    ]);

    dispatch({
      type: 'setStateMultiLayers',
      keys: ['localSettingsCommon', 'appSoundSwitch'],
      value: appSoundSwitchSetting,
    });

    dispatch({
      type: 'setStateMultiLayers',
      keys: ['localSettingsCommon', 'collectibleWordSound'],
      value: collectibleWordSoundSetting,
    });
    closePopup();
  };

  return (
    <div className='flexColumn alignItemsCenter widthMax'>
      <AppSoundSwitchSetting
        appSoundSwitchSetting={appSoundSwitchSetting}
        setAppSoundSwitchSetting={setAppSoundSwitchSetting}
      />
      <CollectibleWordSoundSetting
        collectibleWordSoundSetting={collectibleWordSoundSetting}
        setCollectibleWordSoundSetting={setCollectibleWordSoundSetting}
      />
      <div className='flexRow justifyContentCenter marginTopBottom1 widthMax'>
        <button className='button2 margin0p5'
          onClick={ handleClickOk }
        >
          OK
        </button>
        <button className='button2 margin0p5' onClick={ closePopup }>
          { words.cancel[language] }
        </button>
      </div>
    </div>
  );
}

function AppSoundSwitchSetting({ appSoundSwitchSetting, setAppSoundSwitchSetting }) {
  const language = useGlobalStateSelector(({ state }) => state.language);
  const appSoundSwitchOptions = [
    {
      value: 'on',
      labelKey: 'appSoundSwitchOn',
    },
    {
      value: 'off',
      labelKey: 'appSoundSwitchOff',
    },
  ];

  const optionButtons = appSoundSwitchOptions.map(({ value, labelKey }) => {
    const selectedClass = appSoundSwitchSetting === value ? 'colorRed borderSelected' : 'borderNone';

    return (
      <button className={'button2 textLeft marginTopBottom0p5 marginSide0 paddingSide0p5 widthMax widthMax32 heightAuto heightMin3 ' + selectedClass}
        key={value}
        onClick={ () => {
          setAppSoundSwitchSetting(value);
        }}
      >
        { words[labelKey][language] }
      </button>
    );
  });

  return (
    <>
      <div className='font1p2 margin1'>
        { words.appSoundSwitchSettings[language] }
      </div>
      <div className='flexColumn alignItemsCenter widthMax marginTopBottom1 paddingSide0p5'>
        { optionButtons }
      </div>
    </>
  );
}

function CollectibleWordSoundSetting({ collectibleWordSoundSetting, setCollectibleWordSoundSetting }) {
  const language = useGlobalStateSelector(({ state }) => state.language);
  const collectibleWordSoundOptions = [
    {
      value: 'always',
      labelKey: 'collectibleWordSoundAlways',
    },
    {
      value: 'firstInDuel',
      labelKey: 'collectibleWordSoundFirstInDuel',
    },
    {
      value: 'firstInLifetime',
      labelKey: 'collectibleWordSoundFirstInLifetime',
    },
  ];

  const optionButtons = collectibleWordSoundOptions.map(({ value, labelKey }) => {
    const selectedClass = collectibleWordSoundSetting === value ? 'colorRed borderSelected' : 'borderNone';

    return (
      <button className={'button2 textLeft marginTopBottom0p5 marginSide0 paddingSide0p5 widthMax widthMax32 heightAuto heightMin3 ' + selectedClass}
        key={value}
        onClick={ () => {
          setCollectibleWordSoundSetting(value);
        }}
      >
        { words[labelKey][language] }
      </button>
    );
  });

  return (
    <>
      <div className='font1p2 margin1'>
        { words.collectibleWordSoundSettings[language] }
      </div>
      <div className='flexColumn alignItemsCenter widthMax marginTopBottom1 paddingSide0p5'>
        { optionButtons }
      </div>
    </>
  );
}

// WEBSOCKET INTERFACE
function WebSocketInterface(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const stateRef = useRef(state);

  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  useEffect( () => {
    const addressMain = state.active.addressMain;
    let manualReconnect = false;

    const secWebsocketProtocolObj = {
      addressMain: addressMain,
      sessionId: state.session[addressMain].sessionId,
      connectionMatchingId: 'main',
      duelStatus: state.duel.status,
    };

    const secWebsocketProtocol = btoa(JSON.stringify(secWebsocketProtocolObj)) // Base64
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');

    const websocketClient = new ReconnectingWebSocket(
      () => {
        const stateCurrent = stateRef.current;

        return 'wss://' + process.env.REACT_APP_KOM_WEBSOCKET_DOMAIN + '?reconnect=' + (stateCurrent.webSocketContainer.status === 'handshakedOnDuel' ? 'true' : 'false');
      },
      secWebsocketProtocol,
      {
        maxRetries: 30,
        debug: true
      }
    );

    dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'webSocket'], value: websocketClient});

    let designatedAddresses;
    const csv = state.challengeDuel.designatedAddressesCsv.trim();

    if (csv !== undefined && csv !== null && csv !== '') {
      designatedAddresses = csv.split(/[\r\n,]+/).map( address => { return { address: address }; } );
    }

    const requestBody = {
      action: 'challengeDuel',
      addressMain: state.active.addressMain,
      sessionId: state.session[state.active.addressMain].sessionId,
      connectionMatchingId: 'main',
      gameMode: props.gameMode,
      difficultyMode: props.difficultyMode,
      designatedAddresses: designatedAddresses,
      gameOption: state.challengeDuel.gameOption,
    };

    websocketClient?.send(JSON.stringify(requestBody));


    const onOpen = () => {
      manualReconnect = false;
    };

    websocketClient.addEventListener('open', onOpen);


    const onMessage = (event) => {
      const state = stateRef.current;
      let data;
      // let mySide;
      let opponentSide;
      // let propertyNameMyDeck;
      let propertyNameOpponentDeck;

      if (state.duel.basicInformation?.side === 'A') {
        // mySide = 'A';
        opponentSide = 'B';
        // propertyNameMyDeck = 'duelistADeck';
        propertyNameOpponentDeck = 'duelistBDeck';
      }
      else if (state.duel.basicInformation?.side === 'B') {
        // mySide = 'B';
        opponentSide = 'A';
        // propertyNameMyDeck = 'duelistBDeck';
        propertyNameOpponentDeck = 'duelistADeck';
      }

      devLog(event.data);

      try {
        data = JSON.parse(event.data);

        if (data.type === 'duelText') {
          let chunks = state.duel.chunks;

          const chunkRecoverd = data.body.content
          .replace(/<-KOM control code : new line->/g, '\n')
          .replace(/<-KOM-field->/, '\n<<フィールドの状況>>\n');

          devLog('chunkRecoverd', chunkRecoverd);

          chunks[data.body.count] = chunkRecoverd;
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: chunks});
        }
        else if (data.type === 'duelMessage') {
          if (data.subType === 'waitingInRoom') {
            // デュエルハンドシェイク状態にする。
            dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'status'], value: 'handshakedOnDuel'});

            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation'], value: data.body});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.timeOutTime});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result', 0], value: data.body.result});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: state.config.clientParameters.descriptionAndinstructions});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'waitingInRoom'});
          }
          else if (data.subType === 'duelStandby') {
            // デュエルハンドシェイク状態にする。
            dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'status'], value: 'handshakedOnDuel'});

            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation'], value: data.body});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.timeOutTime});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'waitingToSummon'});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: 1});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result', 0], value: data.body.result});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'maginaPoint'], value: data.body.maginaPoint});
            dispatch({
              type: 'setStateMultiLayers',
              keys: ['duel', 'text'],
              value: state.config.clientParameters.descriptionAndinstructions + '\n\nモナーの名の下に！\n'
              // value: state.config.clientParameters.descriptionAndinstructions + '\n\n<<フィールドの状況>>\n' + data.body.result.field + '\n\nモナーの名の下に！\n'
            });
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'duelStandby'});
          }
          else if (data.subType === 'summonedMonster') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: ''});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'summonedMonster'});
          }
          else if (data.subType === 'battleStandby') {
            let actionOpponent;
            const winner = state.duel.result[state.duel.round - 1].winner;

            if (winner === state.duel.basicInformation.side) {
              actionOpponent = 'summon';
            }
            else if (winner === otherSide(state.duel.basicInformation.side)) {
              actionOpponent = 'skip';
            }
            else {
              actionOpponent = 'summon';
            }

            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: data.body.monstersInformation});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersIndex'], value: data.body.monstersIndex});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: data.body.round});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'actionOpponent'], value: actionOpponent});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.timeOutTime});
          }
          else if (data.subType === 'magicPhase') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: data.body.monstersInformation});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformationRevised'], value: data.body.monstersInformationRevised});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: data.body.magics});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'maginaPoint'], value: data.body.maginaPoint});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'initiative'], value: data.body.initiative});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics'], value: []});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: data.body.round});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result', data.body.round], value: data.body.result});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'magicPhase'});

            // カードオープン
            for (const magic of data.body.magics[opponentSide]) {
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', magic.index, 'asset'], value: magic.asset});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', magic.index, 'visibility'], value: 'open'});

              for (const [index, cost] of magic.costs.entries()) {
                if (state.registeredCard[magic.asset].costs[index].type === 'discardCards') {
                  for (const card of cost.cards) {
                    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', card.index, 'asset'], value: card.asset});
                    dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', card.index, 'visibility'], value: 'open'});
                  }
                }
              }
            }

            // 魔法ナレーション
            let text = '';
            let monsterName = {};

            // -- 同キャラ対決のとき名前に色を付ける。
            if (data.body.monstersInformation.A.asset === data.body.monstersInformation.B.asset) {
              monsterName.A = data.body.monstersInformation.A.name + '(' + sideColor('A') + ')';
              monsterName.B = data.body.monstersInformation.B.name + '(' + sideColor('B') + ')';
            }
            else {
              monsterName.A = data.body.monstersInformation.A.name;
              monsterName.B = data.body.monstersInformation.B.name;
            }

            for (const side of [data.body.initiative, otherSide(data.body.initiative)]) {
              const magic = data.body.magics[side][0];

              if (magic !== undefined) {
                text += monsterName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';
                // text += state.duel.basicInformation.duelistUserName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';

                if (magic.status === 'canceled') {
                  text += 'しかし打ち消された。\n';
                }
              }
            }

            if (text !== '') {
              text += '\n';
            }

            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: text});
          }
          else if (data.subType === 'battleUp') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winner'], value: data.body.winner});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winningMonster'], value: data.body.winningMonster});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winningMonsterIndex'], value: data.body.winningMonsterIndex});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'pointA'], value: data.body.pointA});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'pointB'], value: data.body.pointB});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: data.body.round});
            dispatch({
              type: 'updateUserCollectibleWordsFromBattleUp',
              addressMain: state.active.addressMain,
              result: data.body.result,
              round: data.body.round,
              roomId: state.duel.basicInformation?.roomId,
              duelNo: state.duel.basicInformation?.duelNo,
              language: 'japanese',
            });
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result', data.body.round], value: data.body.result});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'maginaPoint'], value: data.body.maginaPoint});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'initiative'], value: data.body.initiative});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'imageNo'], value: data.body.imageNo});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'knightBoxEffect'], value: data.body.knightBoxEffect});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'cardStatusTmp'], value: { A: [], B: [] }});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'action'], value: null});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'actionOpponent'], value: null});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'battleUp'});

            // タイムアウト時刻
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.timeOutTime});

            // liveTextが流れているときにリカバリした場合は、テキストフィールドを復元する。
            if (state.webSocketContainer.liveText === 'lack') {
              recoverTextField(state, dispatch, {
                monsters: data.body.result.monsters,
                magics: data.body.result.magics,
                initiative: data.body.result.initiative,
                liveText: data.body.result.liveText,
                field: data.body.result.field,
                straightManText: data.body.result.straightManText,
              });

              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: []});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: []});
            }
            
            if (data.body.status === 'onDuel') {
              if (data.body.winner === state.duel.basicInformation.side) {
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'uncomfirmed'});
              } // draw含む。
              else {
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'waitingToSummon'});
              }

              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: data.body.roundNext});

              // 負けた方はundefined
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monsterANextRound'], value: data.body.monsterANextRound});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monsterIndexANextRound'], value: data.body.monsterIndexANextRound});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monsterBNextRound'], value: data.body.monsterBNextRound});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monsterIndexBNextRound'], value: data.body.monsterIndexBNextRound});

              // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics'], value: []});

              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'battleUp'});
            }
            else { // duelUp
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: null});
              dispatch({type: 'setStateMultiLayers', keys: ['user', state.active.addressMain, 'statistics'], value: data.body.statistics});

              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'duelUp'});
            }
          }
          else if (data.subType === 'straightManPhase') {
            let chunks = state.duel.straightManChunks;

            chunks[0] = '\n<<つっこみ>>\n';
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: chunks});
          }
          else {
          }
        }
        else if (data.type === 'straightManText') {
          let chunks = state.duel.straightManChunks;

          const chunkRecoverd = data.body.content
          .replace(/<-KOM control code : new line->/g, '\n')

          devLog('chunkRecoverd', chunkRecoverd);

          chunks[data.body.count] = chunkRecoverd;
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: chunks});
        }
        else if (data.type === 'duelRecovery') {
          const side = data.body.basicInformation.side;
          const roundOnDuel = data.body.roundOnDuel;
          const results = data.body.result;

          // デュエルハンドシェイク状態にする。

          dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'status'], value: 'handshakedOnDuel'});

          // 基本情報を格納

          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation'], value: data.body.basicInformation});

          // その他のリカバリ情報を格納

          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'timeOutTime'], value: data.body.basicInformation.timeOutTime});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'round'], value: roundOnDuel});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'maginaPoint'], value: data.body.basicInformation.maginaPoint});

          // ユーザーオペレーションによる状態変化を格納

          const monstersInformation = {
            A: state.registeredCard[data.body.monsterA],
            B: state.registeredCard[data.body.monsterB],
          };

          const monstersIndex = {
            A: data.body.monsterIndexA,
            B: data.body.monsterIndexB,
          };

          // 前回バトルの結果を確認して、actionを判定する。
          let action;
          let actionOpponent;
          const winner = results[roundOnDuel - 1].winner;

          if (winner === side) {
            action = 'skip';
            actionOpponent = 'summon';
          }
          else if (winner === otherSide(side)) {
            action = 'summon';
            actionOpponent = 'skip';
          }
          else {
            action = 'summon';
            actionOpponent = 'summon';
          }

          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: []});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: []});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: ''});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: monstersInformation});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersIndex'], value: monstersIndex});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'comfirmed'});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: 'onBattle'});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'action'], value: action});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'actionOpponent'], value: actionOpponent});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winner'], value: undefined});
          // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: { [side]: data.body.magics, [otherSide(side)]: [], }});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: data.body.magics});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'imageNo'], value: { A: 0, B: 0, }});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'knightBoxEffect'], value: { A: undefined, B: undefined, }});
          dispatch({type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'visible'});
          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'visible'], value: true});

          // 魔法カードオープン・墓地カード反映

          const propertyNameOpponentDeck = `duelist${otherSide(side)}Deck`;

          for (const result of results) {
            if (result.magics !== undefined) {
              for (const magic of result.magics[otherSide(side)]) {
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', magic.index, 'asset'], value: magic.asset});
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', magic.index, 'visibility'], value: 'open'});

                for (const [index, cost] of magic.costs.entries()) {
                  if (state.registeredCard[magic.asset].costs[index].type === 'discardCards') {
                    for (const card of cost.cards) {
                      dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', card.index, 'asset'], value: card.asset});
                      dispatch({type: 'setStateMultiLayers', keys: ['duel', 'basicInformation', propertyNameOpponentDeck, 'cards', card.index, 'visibility'], value: 'open'});
                    }
                  }
                }
              }
            }
          }

          // resultを配列で格納

          dispatch({type: 'setStateMultiLayers', keys: ['duel', 'result'], value: results});

          if (data.subType === 'summonedMonster') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'pointA'], value: data.body.basicInformation.pointA});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'pointB'], value: data.body.basicInformation.pointB});
            
            // この裏では、liveTextがどんどん流れている。
            dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'liveText'], value: 'lack'});
          }
          else { // battleUpOrDuelUp
            // 魔法反映

            // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformation'], value: results[roundOnDuel].monstersInformation});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'monstersInformationRevised'], value: results[roundOnDuel].monstersInformationRevised});
            // dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics'], value: data.body.magics});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'initiative'], value: data.body.basicInformation.initiative});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics'], value: []});

            // 魔法ナレーション

            let text = '';
            let monsterName = {};

            // -- 同キャラ対決のとき名前に色を付ける。
            if (data.body.monsterA === data.body.monsterB) {
              monsterName.A = state.registeredCard[data.body.monsterA].name + '(' + sideColor('A') + ')';
              monsterName.B = state.registeredCard[data.body.monsterB].name + '(' + sideColor('B') + ')';
            }
            else {
              monsterName.A = state.registeredCard[data.body.monsterA].name;
              monsterName.B = state.registeredCard[data.body.monsterB].name;
            }

            let duelistInOrder;
            const initiative = results[roundOnDuel - 1].initiativeNext;

            if (initiative === 'A' || initiative === 'B') {
              duelistInOrder = [initiative, otherSide(initiative)];
            }
            else { // coinToss, undefined
              duelistInOrder = ['A', 'B'];
            }

            for (const side of duelistInOrder) {
              const magic = data.body.magics[side][0];

              if (magic !== undefined) {
                text += monsterName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';
                // text += state.duel.basicInformation.duelistUserName[side] + 'は ' + state.registeredCard[magic.asset].name + ' を発動した。\n';

                if (magic.status === 'canceled') {
                  text += 'しかし打ち消された。\n';
                }
              }
            }

            // ライブテキスト

            if (text !== '') {
              text += '\n';
            }

            text += results[roundOnDuel].liveText;

            // フィールドの状況

            text += '\n<<フィールドの状況>>\n';
            text += results[roundOnDuel].field;

            // つっこみ

            if (results[roundOnDuel].straightManText !== undefined) {
              text += '\n<<つっこみ>>\n';
              text += results[roundOnDuel].straightManText;
            }

            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'text'], value: text});
          }
        }
        else if (data.type === 'systemMessage') {
          if (data.body.status === 'closedTheRoom') {
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'status'], value: data.body.reason}); // timeUp, timeUpAfterDuelUp, leave, leaveAfterDuelUp
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'myStatus'], value: 'end'});

            if (data.body.reason === 'timeUp' || data.body.reason === 'leave') {
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'winner'], value: data.body.winner});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'duelWinner'], value: data.body.duelWinner});
            }
            else if (data.body.reason === 'timeUpWithoutOpponentComming') {
              handleClickEndDuel(state, dispatch, navigate);
            }
            else {
            }

            websocketClient?.close(1000, 'closedTheRoom');
            dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'webSocket'], value: undefined});
            dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'status'], value: null});
          }
          else if (data.body.status === 'gptError') {
            // gptError または irregularPattern によるリトライのため、デュエルテキストをリセットする。
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'chunks'], value: []});
            dispatch({type: 'setStateMultiLayers', keys: ['duel', 'straightManChunks'], value: []});
          }
          else if (data.body.status === 'transactWriteSummonRejected') {
            // おそらくコンフリクトしているので、リトライする。
            if (state.duel.action === 'summon') {
              const requestBody = {
                action: 'summon',
                addressMain: state.active.addressMain,
                connectionMatchingId: 'main',
                roomId: state.duel.basicInformation.roomId,
                roomSubId: state.duel.basicInformation.roomSubId,
                summonedMonster: state.duel.monstersInformation[state.duel.basicInformation.side].asset, 
                summonedMonsterIndex: state.duel.monstersIndex[state.duel.basicInformation.side],
                castMagics: state.duel.castMagics,
              };

              handleClickSummonMonster(state, dispatch, requestBody);
            }
            else if (state.duel.action === 'skip') {
              const message = {
                action: 'skip',
                addressMain: state.active.addressMain,
                connectionMatchingId: 'main',
                roomId: state.duel.basicInformation.roomId,
                roomSubId: state.duel.basicInformation.roomSubId,
                castMagics: state.duel.castMagics,
              };

              handleClickNext(state, dispatch, message);
            }
          }
          // else if (data.body.status === 'invalidSession') {
          //   handleClickEndDuel(state, dispatch, navigate);
          // }
          // else if (data.body.status === 'noConnection') {
          //   // API Gatewayのタイムアウトを想定。
          //   handleClickEndDuel(state, dispatch, navigate);
          // }
        }
        else { // undefined エラーメッセージ
          const messages = {
            "internal server error": words.internalServerError[state.language],
            "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
            "this address is forbidden.": words.thisAddressIsForbidden[state.language],
            "out of service": words.outOfService[state.language],
            "user does not exist.": words.pleaseRegisterAsAUserOnTheSetupPage[state.language],
            "invalid session.": words.pleaseLogin[state.language],
            "not enough points.": words.notEnoughPoints[state.language],
            "valid points do not exist.": words.notEnoughPoints[state.language],
            [`the number of cards in a deck must be between 3 and ${state.config.clientParameters.numberOfSlots.simple}.`]: words.theNumberOfCardsInADeckMustBeBetween3And7[state.language],
            [`the number of cards in a deck must be between 3 and ${state.config.clientParameters.numberOfSlots.advanced}.`]: words.theNumberOfCardsInADeckMustBeBetween3And11[state.language],
            "you can not use magic cards in simple mode.": words.youCanNotUseMagicCardsInSimpleMode[state.language],
            'gameMode or difficultyMode is unmatched.': words.youArePlayingAnotherDuelWhoseGameModeIsDifferent[state.language],
          };

          if (data.applicationMessage !== undefined && messages[data.applicationMessage] !== undefined) {
            dispatch({ type: 'setNotification', key: 'notification', value: messages[data.applicationMessage] });
          }
        }
      }
      catch (error) {
        // エラー通知
        devLog('irregular WebSocket data.', error);
      }
    };

    websocketClient.addEventListener('message', onMessage);


    // 事故切断の再接続本体は RWS の自動再接続。
    // close 時に RWS はリスナーより先に _connect() する。ここでの reconnect() は二重起動ではなく、retryCount を戻す追い打ち。
    // close と error の両方で来るため、manualReconnect で二回目を抑える。
    const onClose = (event) => {
      const state = stateRef.current;
      devLog('WebSocket closed.', JSON.stringify(event), 'code:', event.code, 'reason:', event.reason, 'wasClean:', event.wasClean);

      // if (event.code === 1000 && event.reason === 'leave' && event.wasClean === true) {
      //   // 超絶正常
      //   // 何もしない。
      //   // duelは呼び出し元で消されている。
      //   // イベントハンドラはアンマウント時、またはunload時に消される。
      //   // websocketClientはアンマウント時、またはunload時にstateから消される。
      // }
      if (event.code === 1001 && event.reason === 'Going away' && event.wasClean === true) {
        // API Gatewayのタイムアウトを想定。
        // サーバサイドからの切断で、既にduelは終了しているので、duelを消しに行く。
        // イベントハンドラはアンマウント時、またはunload時に消される。
        // websocketClientはアンマウント時、またはunload時にstateから消される。

        handleClickEndDuel(state, dispatch, navigate);
      }
      else if (event.code === 1000 && event.reason === 'unloaded' && event.wasClean === true) {
        // 何もしない。
        // duelはそのまま。
        // イベントハンドラはアンマウント時、またはunload時に消される。
        // websocketClientはアンマウント時、またはunload時にstateから消される。
      }
      else if (event.code === 1000 && event.reason === 'cleanUp' && event.wasClean === true) {
        // 何もしない。
        // duelはそのまま。
        // イベントハンドラはアンマウント時、またはunload時に消される。
        // websocketClientはアンマウント時、またはunload時にstateから消される。
      }
      else if (event.code === 1000 && event.reason === 'closedTheRoom' && event.wasClean === true) {
        // 何もしない。
        // duelは終了状態の表示を維持する。
      }
      else {
        // 再接続

        let additionalMessage = '';

        if (!manualReconnect) {
          console.log('try reconnect');
          console.log(state.webSocketContainer.webSocket);
          manualReconnect = true;
          websocketClient.reconnect();
        }
        else {
          console.log('suppressedReconnect');
          additionalMessage = 'suppressedReconnect';
        }

        // 通知

        sendLog({
          action: 'notifyWithSession',
          addressMain: state.active.addressMain,
          sessionId: state.session[state.active.addressMain].sessionId,
          message: `WebSocket closed ${additionalMessage}; ${JSON.stringify(event)}, code: ${event.code}, reason: ${event.reason}, wasClean: ${event.wasClean}`,
        });
      }
    };

    websocketClient.addEventListener('close', onClose);


    const onError = (event) => {
      const state = stateRef.current;
      devLog('WebSocket error.', JSON.stringify(event), 'code:', event.code, 'reason:', event.reason, 'wasClean:', event.wasClean);

      // if (event.code === 1000 && event.reason === 'leave' && event.wasClean === true) {
      //   // 超絶正常
      //   // RWS 内部では
      //   // あなたの close() 呼び出し → ラッパーが close を転送
      //   // そのあと keepClosed:true を見て 再接続を止める
      //   // ネイティブソケットが物理的に切れるとき、OS/TCP スタック側の “I/O エラー” が発生すると
      //   // RWS はそれも「error イベント」として そのまま dispatchEvent("error", …)
      //   // つまり **「close した直後に I/O がエラー扱いで片付いた」**場合は
      //   // close  →  error  →  (再接続しない)
      //   // という順序で 両方 見えることがあります。
      //   // これは RWS の実装仕様であって、異常ではありません。

      //   // 何もしない。
      //   // duelは呼び出し元で消されている。
      //   // イベントハンドラはアンマウント時、またはunload時に消される。
      //   // websocketClientはアンマウント時、またはunload時にstateから消される。
      // }
      if (event.code === 1001 && event.reason === 'Going away' && event.wasClean === true) {
        // API Gatewayのタイムアウトを想定。
        // サーバサイドからの切断で、既にduelは終了しているので、duelを消しに行く。
        // イベントハンドラはアンマウント時、またはunload時に消される。
        // websocketClientはアンマウント時、またはunload時にstateから消される。

        handleClickEndDuel(state, dispatch, navigate);
      }
      else if (event.code === 1000 && event.reason === 'unloaded' && event.wasClean === true) {
        // 何もしない。
        // duelはそのまま。
        // イベントハンドラはアンマウント時、またはunload時に消される。
        // websocketClientはアンマウント時、またはunload時にstateから消される。
      }
      else if (event.code === 1000 && event.reason === 'cleanUp' && event.wasClean === true) {
        // 何もしない。
        // duelはそのまま。
        // イベントハンドラはアンマウント時、またはunload時に消される。
        // websocketClientはアンマウント時、またはunload時にstateから消される。
      }
      else if (event.code === 1000 && event.reason === 'closedTheRoom' && event.wasClean === true) {
        // 何もしない。
        // duelは終了状態の表示を維持する。
      }
      else {
        // 再接続

        let additionalMessage = '';

        if (!manualReconnect) {
          console.log('try reconnect');
          console.log(state.webSocketContainer.webSocket);
          manualReconnect = true;
          websocketClient.reconnect();
        }
        else {
          additionalMessage = 'suppressedReconnect';
        }

        // 通知
        sendLog({
          action: 'notifyWithSession',
          addressMain: state.active.addressMain,
          sessionId: state.session[state.active.addressMain].sessionId,
          message: `WebSocket error ${additionalMessage}; ${JSON.stringify(event)}, code: ${event.code}, reason: ${event.reason}, wasClean: ${event.wasClean}`,
        });
      }
    };

    websocketClient.addEventListener('error', onError);


    const beforeUnload = () => {
      try {
        websocketClient?.close(1000, 'unloaded');
        websocketClient?.removeEventListener('open', onOpen);
        websocketClient?.removeEventListener('message', onMessage);
        websocketClient?.removeEventListener('error', onError);
        websocketClient?.removeEventListener('close', onClose);
        devLog('closed WebSocket.');
      }
      catch (error) {
        devLog('WebSocket may already be closed.', error);
      }

      dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'webSocket'], value: undefined});
      dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'status'], value: null});
      cleanUpDuelInState(state, dispatch);

      window.removeEventListener('beforeunload', beforeUnload, true);
    }

    window.addEventListener('beforeunload', beforeUnload, true);


    return () => {
      try {
        websocketClient?.close(1000, 'cleanUp');
        websocketClient?.removeEventListener('open', onOpen);
        websocketClient?.removeEventListener('message', onMessage);
        websocketClient?.removeEventListener('error', onError);
        websocketClient?.removeEventListener('close', onClose);
        devLog('WebSocket closed');
      }
      catch (error) {
        devLog('WebSocket may already be closed.', error);
      }

      dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'webSocket'], value: undefined});
      dispatch({type: 'setStateMultiLayers', keys: ['webSocketContainer', 'status'], value: null});
      cleanUpDuelInState(state, dispatch);

      window.removeEventListener('beforeunload', beforeUnload, true);
    };
  }, []);

  return (
    <div>
    </div>
  );
}

// NOW LOADING
function NowLoading() {
  return (
    <div className='flexColumn justifyContentCenter alignItemsCenter width100vw height100vh ' >
      <div className='font2 ' >
        { 'now loading' }
      </div>
    </div>
  );
}

// PLEASE LOGIN
function PleaseLogin() {
  const state = useGlobalStateSelector(({ state }) => state);


  return (
    <div className='flexColumn justifyContentCenter alignItemsCenter width100vw height100vh ' >
      <img className='size2x2' src={monaFavicon} alt='' />
      <div className=''>
        { words.pleaseLogin[state.language] }
      </div>
    </div>
  );
}

// CLOCK
function Clock() {
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const clockIntervalSec = 500;

  useEffect( () => {
    const clockInterval = setInterval( async () => {
      const now = new Date();

      dispatch({type: 'setState', key: 'clock', value: now.getTime()});
    }, clockIntervalSec);

    return () => {
      clearInterval(clockInterval);
    }
  }, []);

  return null;
}

// NEXT BUTTON
function NextButton(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const popupLayers = props.popupLayers;

  let nextButton;

  if (state.duel.myStatus === 'uncomfirmed' && state.duel.selectStatus.mode === 'neutral') {
    nextButton =
    <button className='button2 pointerEventsAuto '
      onClick={ () => {
        const message = {
          action: 'skip',
          addressMain: state.active.addressMain,
          connectionMatchingId: 'main',
          roomId: state.duel.basicInformation.roomId,
          roomSubId: state.duel.basicInformation.roomSubId,
          castMagics: state.duel.castMagics,
        };

        handleClickNext(state, dispatch, message);

        if (popupLayers !== undefined) {
          for (const popupLayer of popupLayers) {
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } })
          }
        }
      }}
    >
      OK
    </button>
  }

  return nextButton;
}

// MAGINA POINT
function MaginaPoint(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const side = props.side;
  const baseClass = props.baseClass;
  const initiativeClass = props.initiativeClass;

  if (state.duel.basicInformation?.difficultyMode === 'simple') {
    return null;
  }

  let maginaPoint;

  if (side !== undefined) {
    let additionalClass;

    if (state.duel.initiative === side && state.duel.status === 'battleUp') {
      // maginaPointClass = 'padding0p5 borderFat borderRadius0p5 ' + borderColor(side);
      additionalClass = initiativeClass;
    }
    else if (state.duel.initiative === otherSide(side) && state.duel.status === 'battleUp') {
      additionalClass = '';
    }
    else { // coinToss
      additionalClass = '';
    }

    maginaPoint =
    <div className={ baseClass + ' ' + additionalClass } > 
      { 'MP ' + state.duel.maginaPoint[side] }
    </div> 
  }

  return maginaPoint;
}

// MAGINA POINT APPLIED
function MaginaPointApplied(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const side = props.side;
  const sideRelative = props.sideRelative;
  const device = props.device;
  const magic = state.duel.magics?.[side]?.[0];
  const maginaPoint = state.duel.maginaPoint;

  let maginaPointApplied;

  if (magic !== undefined) {
    if (sideRelative === 'other' || state.duel.castMagics[0] === undefined) {
      if (device === 'SP') {
        maginaPointApplied =
        <div className={ 'padding0p3 font0p7 borderThin borderRadius0p5 ' + borderColor(maginaPoint.applied.side) } > 
          { '<< ' + maginaPoint.applied.point }
        </div> 
      }
      else { // PC
        maginaPointApplied =
        <div className={ 'padding0p5 borderThin borderRadius0p5 ' + borderColor(maginaPoint.applied.side) } > 
          { maginaPoint.applied.point }
        </div> 
      }
    }
  }

  return maginaPointApplied;
}

// MAGINA GAUGE
function MaginaGauge(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const side = props.side;
  const sideRelative = props.sideRelative;
  const direction = props.direction;
  const noMagic = props.noMagic;
  const magic = state.duel.magics?.[side]?.[0];
  const maginaPoint = state.duel.maginaPoint;

  const backgroundColorClass = {
    A: 'classBackGroundA',
    B: 'classBackGroundB',
  };

  let maginaGauge;

  // if (state.duel.maginaPoint.applied !== undefined && state.duel.maginaPoint.applied !== null) {
  //   maginaPoint = state.duel.maginaPoint.applied;
  // }
  // else {
  //   maginaPoint = state.duel.maginaPoint[side];
  // }

  if (magic !== undefined) {
    const maginaThresholds = state.registeredCard[magic.asset].maginaThresholds;
    const thresholdsWithBox = maginaThresholds.map( threshold => {
      return {
        upperBound: threshold.upperBound,
        face: threshold.face,
        box: [],
      };
    });

    if (sideRelative === 'other' || state.duel.castMagics[0] === undefined) {
      for (const threshold of thresholdsWithBox) {
        if (maginaPoint.applied.point < threshold.upperBound) {
          threshold.box.push({ side: maginaPoint.applied.side, point: maginaPoint.applied.point })
          break;
        }
      }
    }
    else {
      for (const side of ['A', 'B']) {
        for (const threshold of thresholdsWithBox) {
          if (maginaPoint[side] < threshold.upperBound) {
            threshold.box.push({ side: side, point: maginaPoint[side] })
            break;
          }
        }
      }
    }

    if (direction === 'horizontal') {
      maginaGauge =
      <div className='flexRow alignItemsCenter borderMonacotto padding0p3' >
        <div className='textCenter height1p6 font0p7' >
          { '0' }
        </div>
        {
          thresholdsWithBox.map( threshold =>
              <div className='flexRowReverse justifyContentCenter alignItemsCenter ' >
                <div className='textCenter height1p6 font0p7' >
                  { threshold.face !== undefined ? threshold.face : threshold.upperBound }
                </div>
                <div className='flexColumn justifyContentCenter alignItemsCenter width1 height1p6' >
                  {
                    threshold.box.map( ball => 
                      <div className={'width0p7 height0p7 borderRadiusCircle ' + backgroundColorClass[ball.side]} >
                      </div>
                    )
                  }
                </div>
              </div>
          )
        }
      </div>;
    }
    else { // vertical
      maginaGauge =
      <div className='flexColumnReverse alignItemsCenter borderMonacotto' >
        <div className='textCenter width2p4 height1p2' >
          { '0' }
        </div>
        {
          thresholdsWithBox.map( threshold =>
              <div className='flexColumn justifyContentCenter alignItemsCenter ' >
                <div className='textCenter width2p4 height1p2' >
                  { threshold.face !== undefined ? threshold.face : threshold.upperBound }
                </div>
                <div className='flexRow justifyContentCenter alignItemsCenter width2p4 height1p2' >
                  {
                    threshold.box.map( ball => 
                      <div className={'width1 height1 borderRadiusCircle ' + backgroundColorClass[ball.side]} >
                      </div>
                    )
                  }
                </div>
              </div>
          )
        }
      </div>;
    }
  }
  else {
    if (noMagic === 'blank') {
      maginaGauge = null;
    }
    else {
      maginaGauge =
      <div className='flexColumnReverse alignItemsCenter borderMonacotto' >
      </div>;
    }
  }

  return maginaGauge;
}

// TARGET INDICATION
function TargetIndication(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const thisSide = props.side;
  let textClass = props.textClass;

  if (textClass === undefined) {
    textClass = '';
  }

  if (state.duel.magics?.[thisSide]?.[0]?.targets !== undefined) {
    const targets = state.duel.magics[thisSide][0].targets;
    // const targetsReduced = targets.reduce( (acc, cur) => acc + Object.keys(cur).reduce( (acc2, cur2) => `${acc2}${words[cur2][state.language]}: ${words[cur[cur2].thisSide][state.language]} `, ''), '');

    const targetsReduced = targets.reduce( (acc, cur) =>
      acc + Object.keys(cur).reduce( (acc2, cur2) => {
        if (cur[cur2].side !== undefined && cur[cur2].side !== null) {
          return `${acc2}${words[cur[cur2].side][state.language]} `
        }
        else {
          return acc;
        }
      }, ''),
    '');

    if (targetsReduced !== '') {
      return (
        <div className={'borderKOM borderRadius0p3 margin0p5 padding0p5 ' + textClass} >
          { targetsReduced }
        </div>
      );
    }
  }
  
  return null;
}

// CANCEL MAGIC
function CancelMagic() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);

  let cancelMagic;

  if ((state.duel.myStatus === 'waitingToSummon' || state.duel.myStatus === 'uncomfirmed') && state.duel.castMagics.length >= 1) {
    cancelMagic =
    <button className='button2' onClick={ () => { handleClickCancelMagic(state, dispatch, 0) }} >
      { words.cancel[state.language] }
    </button>;
  }

  return cancelMagic;
}

// FLASH
function Flash() {
  const animation = useAnimation(
    [
      { opacity: "1" },
      { opacity: "0" },
    ],
    {
      duration: 100,
      iterations: 10,
      easing: "ease-in-out",
    }
  );

  useEffect(() => {
    animation.play();
  }, []);

  return (
      <div
        ref={animation}
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          border: "none",
          // border: "2px solid black",
          backgroundColor: "white",
          // top: "50%",
          // left: "50%",
          // transform: "translate(-50%,-50%)",
          zIndex: "300",
          pointerEvents: "none",
        }}
      >
        {/* <img className='widthMax heightMax' src={logoWin} /> */}
      </div>
  );
}

// DECK ON DUEL
function DeckOnDuel(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  // const side = props.side;
  const deck = props.deck;
  const sideRelative = props.sideRelative;

  const mySide = state.duel.basicInformation?.side;
  let thisSide;
  let otherSide;

  if (sideRelative === 'self') {
    if (mySide === 'A') {
      thisSide = 'A';
      otherSide = 'B';
    }
    else {
      thisSide = 'B';
      otherSide = 'A';
    }
  }
  else { // other
    if (mySide === 'A') {
      thisSide = 'B';
      otherSide = 'A';
    }
    else {
      thisSide = 'A';
      otherSide = 'B';
    }
  }

  /*
  if (mySide === 'A') {
    deck = state.duel.basicInformation.duelistADeck;
  }
  else { // B
    deck = state.duel.basicInformation.duelistADeck;
  }
  */

  const losingMonsters = state.duel.result
  .filter( round => round.winner === otherSide ) // drawは除外される。
  .map( round => round.monstersIndex[thisSide] );

  let cards;

  if (deck !== undefined) {
    cards = deck?.cards.map ( (card, index) =>
      <CardOnDuel
        asset={card.asset}
        index={index}
        visibility={card.visibility}
        side={thisSide}
        sideRelative={sideRelative}
        losing={losingMonsters.includes(index)}
        styleSize='small'
      />
    );
  }
  else {
    cards = [];
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexRow flexWrapNoWrap maxWidth97vw scrollXAuto '>
          { cards.map( card => <div className='width11 ' >{ card }</div> ) }
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess">
        <div className='flexRow'>
          { cards }
        </div>
      </div>
    </div>
  );
}

// DECK ON DUEL SP
function DeckOnDuelSP(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  // const side = props.side;
  const popupLayer = props.popupLayer;
  const deck = state.popup[popupLayer].body.deck;
  const sideRelative = state.popup[popupLayer].body.sideRelative;
  const mySide = state.duel.basicInformation?.side;

  let thisSide;
  let otherSide;
  // let thisSideClass;
  let thisSideBackGround;
  let thisSideAlternativeMagic;
  let nextButton;

  if (sideRelative === 'self') {
    if (mySide === 'A') {
      thisSide = 'A';
      otherSide = 'B';
      // thisSideClass = 'classA';
      thisSideBackGround = 'classBackGroundA';
      thisSideAlternativeMagic = 'imageMagicRed';
    }
    else {
      thisSide = 'B';
      otherSide = 'A';
      // thisSideClass = 'classB';
      thisSideBackGround = 'classBackGroundB';
      thisSideAlternativeMagic = 'imageMagicBlue';
    }

    nextButton = <NextButton popupLayers={[popupLayer]} />;
  }
  else { // other
    if (mySide === 'A') {
      thisSide = 'B';
      otherSide = 'A';
      // thisSideClass = 'classB';
      thisSideBackGround = 'classBackGroundB';
      thisSideAlternativeMagic = 'imageMagicBlue';
    }
    else {
      thisSide = 'A';
      otherSide = 'B';
      // thisSideClass = 'classA';
      thisSideBackGround = 'classBackGroundA';
      thisSideAlternativeMagic = 'imageMagicRed';
    }
  }

  const losingMonsters = state.duel.result
  .filter( round => round.winner === otherSide ) // drawは除外される。
  .map( round => round.monstersIndex[thisSide] );

  const cards = deck?.cards.map ( (card, index) =>
    <CardOnDuel
      asset={card.asset}
      index={index}
      visibility={card.visibility}
      side={thisSide}
      sideRelative={sideRelative}
      losing={losingMonsters.includes(index)}
      device='SP'
      styleSize='small'
    />
  );

  // 詠唱魔法

  let thisSideMagic;
  let cancelMagic;
  // let targetIndication;

  thisSideMagic =
  <CardOnDuel
    asset={ state.duel.magics?.[thisSide]?.[0]?.asset }
    index={ state.duel.magics?.[thisSide]?.[0]?.index }
    side={thisSide}
    alternative={thisSideAlternativeMagic}
    device='SP'
    styleSize='small'
    position='cast'
  />;

  if (sideRelative === 'self') {
    cancelMagic =
    <div className='marginRight0p5' >
      <CancelMagic />
    </div>;
  }
  else {
    cancelMagic = null;
  }

  let magicInformation;

  if (state.duel.basicInformation?.difficultyMode === 'advanced') {
    magicInformation =
    <>
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter widthMax ' >
        <div className='flexRow justifyContentFlexStart alignItemsCenter marginLeft0p5' >
          { thisSideMagic }
          <div className='flexColumn justifyContentFlexStart alignItemsCenter marginSide0p5' >
            <MaginaPoint side={thisSide} baseClass='padding0p5' initiativeClass={'borderFat borderRadius0p5 ' + borderColor(thisSide)} />
            <TargetIndication side={thisSide} />
          </div>
        </div>
        { cancelMagic }
      </div>
      <div className='marginSide1 marginTop0p5' >
        <MaginaGauge side={thisSide} sideRelative={sideRelative} direction='horizontal' noMagic='blank' />
      </div>
    </>;
  }
  else {
    magicInformation = null;
  }

  let magicInstruction;

  if (sideRelative === 'self') {
    magicInstruction =
    <div className='marginSide1 marginTop0p5' >
      <MagicInstruction />
    </div>;
  }
  else {
    magicInstruction = null;
  }


  return (
    <div className='visibleSmallOrLess'>
      <div className={'deckPopup flexColumn alignItemsFlexStart marginTop0p5 ' + thisSideBackGround} >
        { magicInformation }
        { magicInstruction }
        <div className='flexRow justifyContentSpaceAround alignItemsCenter marginTop0p5 ' >
          { cards }
        </div>
        <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMax marginTop0p5' >
          { nextButton }
          <button className='button2' onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } }) } >
            { words.close[state.language] }
          </button>
        </div>
      </div>
      { <SelectControlButton layer={popupLayer + 1} /> }
    </div>
  );
}

// CARD ON DUEL
function CardOnDuel(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const side = props.side;
  // const round = state.duel.round;
  const asset = props.asset;
  const index = props.index;
  const visibility = props.visibility;
  // const losing = props.losing;
  const device = props.device;
  const sideRelative = props.sideRelative;
  const position = props.position;
  const category = state.registeredCard[asset]?.category;
  const cardStatus = getCardStatus(state, side, index);
  const cardStatusTmp = getCardStatusTmp(state, side, index);

  let styleBox;
  let styleCard;
  let styleBoxSP;
  let styleCardSP;

  if (props.styleSize === 'small') {
    styleBox = 'boxCardSmall';
    styleCard = 'cardImageSmall';
    styleBoxSP = 'boxCardSP';
    styleCardSP = 'cardImageSmallSP';
  }
  else {
    styleBox = 'boxCard';
    styleCard = 'cardImage';
    styleBoxSP = 'boxCardSP';
    styleCardSP = 'cardImageSP';
  }

  let styleBoxColor = '';
  let styleBorderColor = '';
  let styleBoxPadding = '';

  if (asset !== undefined) {
    if (position !== 'cast' && position !== 'field') {
      if (state.registeredCard[asset].category === 'magic') {
        styleBoxColor = ' backgroundColorLightGreen';
        styleBorderColor = ' borderDeepGreenFat';
        styleBoxPadding = ' padding0p5';
      }
      else if (state.registeredCard[asset].category !== 'magic') {
        styleBoxPadding = ' padding0p5';
      }
      else {
      }
    }
    else {
    }
  }
  else {
  }

  styleBox += styleBoxColor + styleBorderColor;
  styleBoxSP += styleBoxColor + styleBorderColor + styleBoxPadding;

  // -- カードステータス

  let monsterStatus;
  let screen;

  if (position === 'field') {
    monsterStatus = null;
    screen = null;
  }
  else if (position === 'cast') {
    monsterStatus = null;
    screen = null;
  }
  // if (losing === true) 
  else if (cardStatusTmp === 'cast') {
    if (side === 'A') {
      monsterStatus =
      <div className='monsterStatus width75PC '>
        <img className='width70P' src={imageMagicRed} alt='cast' />
      </div>
    }
    if (side === 'B') {
      monsterStatus =
      <div className='monsterStatus width75PC '>
        <img className='width70P' src={imageMagicBlue} alt='cast' />
      </div>
    }

    screen =
    <div className='screen140'>
    </div>;
  }
  else if (cardStatusTmp === 'cost') {
    monsterStatus =
    <div className='monsterStatus width75PC '>
      <img className='width70P' src={imageCost} alt='cost' />
    </div>

    screen =
    <div className='screen140'>
    </div>;
  }
  else if (cardStatusTmp === 'costToBeExcludedFromCemetery') {
    monsterStatus =
    <div className='monsterStatus width75PC '>
      <img className='width70P' src={imageCostToBeExcludedFromCemetery} alt='costToBeExcludedFromCemetery' />
    </div>

    screen =
    <div className='screen140'>
    </div>;
  }
  else if (cardStatus === 'cemetery') {
    monsterStatus =
    <div className='monsterStatus width75PC '>
      {/* <img className='widthMax' src={logoLose} /> */}
      <img className='width70P' src={imageCemetery} alt='cemetery' />
    </div>

    screen =
    <div className='screen140'>
    </div>;
  }
  else if (cardStatus === 'anotherDimension') {
    monsterStatus =
    <div className='monsterStatus width75PC '>
      {/* <img className='widthMax' src={logoLose} /> */}
      <img className='width70P' src={imageAnotherDimension} alt='anotherDimension' />
    </div>

    screen =
    <div className='screen140'>
    </div>;
  }
  else {
    monsterStatus = null;
    screen = null;
  }

  // -- 対象表示

  let targetIndication;

  if (state.duel.cardStatusTmp[side]?.[index]?.targets !== undefined) {
    if (state.duel.cardStatusTmp[side][index].targets.length > 0) {
      targetIndication =
      <div className='target width75PC '>
        <img className='width70P' src={imageTarget} alt='target' />
      </div>

      // screen =
      // <div className='screen140'>
      // </div>;
    }
  }

  let cardImageUrl;
  let cardImage;
  let cardName;
  // let cardImageUrlSP;
  let cardImageSP;
  // let cardNameSP;
  let summonButtonSP;

  // クリックアクション関数

  const summonMonsterFunction = () => {
    if (sideRelative === 'self' && state.duel.myStatus === 'waitingToSummon' && index !== undefined && cardStatus === 'hand' && cardStatusTmp === 'available') {
      const requestBody = {
        action: 'summon',
        addressMain: state.active.addressMain,
        connectionMatchingId: 'main',
        roomId: state.duel.basicInformation.roomId,
        roomSubId: state.duel.basicInformation.roomSubId,
        summonedMonster: asset, 
        summonedMonsterIndex: index,
        castMagics: state.duel.castMagics,
      };

      handleClickSummonMonster(state, dispatch, requestBody);

      if (device === 'SP') {
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: { type: null, body: null } }) // ちゃんとpropsでpopupLayer受け取ってもいいよ。
      }
    }
    else {
    }
  }

  const costMonsterFunction = () => {
    if (
      sideRelative === 'self' &&
      (state.duel.myStatus === 'waitingToSummon' || state.duel.myStatus === 'uncomfirmed') &&
      index !== undefined &&
      // cardStatus === 'hand' &&
      cardStatusTmp === 'available' // いずれ、もっと細かいチェックをすべし。 → それは関数に任せる。
    ) {
      handleClickCostMonster(state, dispatch, asset, index);
    }
    else {
    }
  }

  const selectMonsterCardFromMyCemeteryFunction = () => {
    if (
      sideRelative === 'self' &&
      (state.duel.myStatus === 'waitingToSummon' || state.duel.myStatus === 'uncomfirmed') &&
      index !== undefined &&
      cardStatus === 'cemetery' &&
      category !== 'magic' &&
      cardStatusTmp === 'available' // いずれ、もっと細かいチェックをすべし。
    ) {
      handleClickSelectCemeteryCard(state, dispatch, side, asset, index);
    }
    else {
    }
  }

  const castMagicFunction = () => {
    if (sideRelative === 'self' && (state.duel.myStatus === 'waitingToSummon' || state.duel.myStatus === 'uncomfirmed') && index !== undefined && cardStatus === 'hand' && cardStatusTmp === 'available') {
      handleClickCastMagic(state, dispatch, asset, index);
    }
    else {
    }
  }

  const viewCardDetailFunction = (params) => { // あまりにもひどすぎる。
    const body = {
      monster: {
        asset: asset, 
        index: index,
      },
      item: {
        asset: asset, 
        index: index,
      },
      side: side,
      position: position,
      actionBox: params.actionBox,
    };

    const popup = { type: params.popupType, body: body };
    dispatch({ type: 'setStateMultiLayers', keys: ['popup', params.popupLayer], value: popup });
  }

  if (visibility === 'hidden') {
    // ひみつ画像
    cardImage =
    <button className={styleBox + ' '} disabled={props.disabled ? true : false} >
        <div className={styleCard + ' relative flexColumn '} >
          { screen }
          <img className='widthMax' src={imageHiddenMagic} alt='hidden magic' />
        </div>
        { monsterStatus }
        { targetIndication }
    </button>

    cardImageSP =
    <button className={styleBoxSP + ' padding0p5'} disabled={props.disabled ? true : false} >
        <div className={styleCardSP + ' relative flexColumn '} >
          { screen }
          <img className='widthMax' src={imageHiddenMagic} alt='hidden magic' />
        </div>
        { monsterStatus }
        { targetIndication }
    </button>

    cardName = null;
    summonButtonSP = null;
  }
  else if (asset === undefined) {
    // 代替画像
    if (props.alternative === 'emblemRed') {
      cardImage =
      <div className='flexColumn justifyContentCenter height27 ' >
        <img className={styleCard} src={emblemRed} alt='emblem red' />
      </div>

      cardImageSP =
      <div className='flexColumn justifyContentCenter heightEmblemSP' >
        <img className={styleCardSP} src={emblemRed} alt='emblem red' />
      </div>
    }
    else if (props.alternative === 'emblemBlue') {
      cardImage =
      <div className='flexColumn justifyContentCenter height27 ' >
        <img className={styleCard} src={emblemBlue} alt='emblem blue' />
      </div>

      cardImageSP =
      <div className='flexColumn justifyContentCenter heightEmblemSP' >
        <img className={styleCardSP} src={emblemBlue} alt='emblem blue' />
      </div>
    }
    else if (props.alternative === 'imageMagicRed') {
      cardImage =
      <div className='flexColumn justifyContentCenter marginTop2' >
        <img className={styleCard} src={imageMagicRed} alt='magic red' />
      </div>

      cardImageSP =
      <div className='flexColumn justifyContentCenter ' >
        <img className={styleCardSP} src={imageMagicRed} alt='magic red' />
      </div>
    }
    else if (props.alternative === 'imageMagicBlue') {
      cardImage =
      <div className='flexColumn justifyContentCenter marginTop2' >
        <img className={styleCard} src={imageMagicBlue} alt='magic blue' />
      </div>

      cardImageSP =
      <div className='flexColumn justifyContentCenter ' >
        <img className={styleCardSP} src={imageMagicBlue} alt='magic blue' />
      </div>
    }
    else {
      return null;
    }

    cardName = null;
    summonButtonSP = null;
  }
  else {
    // カード画像

    if (position === 'field' && state.duel.imageNo[side] !== 0) {
      // if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
      //   cardImageUrl = `https://knightsofmonadom.monatoka.com/monacard/${asset}_${state.duel.imageNo[side]}.png`;
      // }
      // else { // dev
      //   cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/${asset}_${state.duel.imageNo[side]}.png`;
      // }

      cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}${asset}_${state.duel.imageNo[side]}.png`;
    }
    else {
      // cardImageUrl = `https://dev.knightsofmonadom.monatoka.com/monacard/${asset}.png`;

      cardImageUrl = `https://${process.env.REACT_APP_MONACARD_URL}${asset}.png`;
    }

    // クリックアクション

    let onClickFunction;

    if (position === 'field' || position === 'cast') {
      onClickFunction = viewCardDetailFunction;
    }
    else {
      if (state.duel.selectStatus.mode === 'neutral') {
        if (state.registeredCard[asset].category === 'magic') {
          onClickFunction = castMagicFunction;
        }
        else { // monster
          onClickFunction = summonMonsterFunction;
        }
      }
      else if (state.duel.selectStatus.mode === 'magic') {
        if (getSelectStatusType(state) === 'cost') {
          onClickFunction = costMonsterFunction;
        }
        else if (getSelectStatusType(state) === 'target') {
          if (getRoute(state).detail.source === 'cemeteryMyself') {
            if (getRoute(state).detail.category === 'monster') {
              onClickFunction = selectMonsterCardFromMyCemeteryFunction;
            }
          }
        }
        else {
          onClickFunction = null;
        }
      }
    }

    // カード画像ボタン

    cardImage =
    <button className={styleBox + ' '} disabled={props.disabled ? true : false}
      onClick={ () => onClickFunction({popupType: 'monsterDetail', popupLayer: 0}) } // ちゃんとpropsでpopupLayer受け取ってもいいよ。
    >
      <div className={styleCard + ' relative flexColumn '} >
        { screen }
        <img className='widthMax' src={cardImageUrl} alt='card' />
      </div>
      { monsterStatus }
      { targetIndication }
    </button>

    cardImageSP =
    <button className={styleBoxSP + ' '} disabled={props.disabled ? true : false}
      onClick={ () => {
        onClickFunction({popupType: 'itemDetailSP', popupLayer: 1, actionBox: 'close'}); // ちゃんとpropsでpopupLayer受け取ってもいいよ。

        if (position === 'field' || position === 'cast') {
          dispatch({ type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'invisible' });
        }
      }}
    >
      <div className={styleCardSP + ' relative flexColumn '} >
        { screen }
        <img className='widthMax' src={cardImageUrl} alt='card' />
      </div>
      { monsterStatus }
      { targetIndication }
    </button>

    // 補正カード名

    let nameRevised;

    if (position === 'field' && state.duel.monstersInformationRevised?.[side]?.name !== undefined) {
      nameRevised = state.duel.monstersInformationRevised?.[side]?.name;
    }
    else {
      nameRevised = state.registeredCard[asset].name;
    }

    // 魔法カラー

    let backgroundColor;

    // if (state.registeredCard[asset].category === 'magic' && position !== 'cast') {
    //   backgroundColor = 'backgroundColorMagic';
    // }
    // else {
    //   backgroundColor = 'backgroundColorTransparent';
    // }

    backgroundColor = 'backgroundColorTransparent';

    // カード名ボタン

    cardName =
    <button className={'heightMin3 borderNone cursor borderRadius2 riseOut2 marginSide0p2 marginTop0p5 ' + backgroundColor} disabled={props.disabled ? true : false}
      onClick={ () => viewCardDetailFunction({popupType: 'monsterDetail', popupLayer: 0}) } // ちゃんとpropsでpopupLayer受け取ってもいいよ。
    >
      { nameRevised }
    </button>

    /*
    cardNameSP =
    <button className='heightMin1 borderNone backgroundColorTransparent cursor borderRadius2 riseOut2 marginSide0p2 marginTop0p5 font0p5' disabled={props.disabled ? true : false}
      onClick={ () => {
          const monster = {
            asset: asset, 
            index: index,
          };

          const popup = { type: 'monsterDetail', body: monster };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', 1], value: popup });
      }}
    >
      { state.registeredCard[asset].name }
    </button>
    */

    // スマートフォンカード詳細ボタン

    // if (sideRelative === 'self' && state.duel.myStatus === 'waitingToSummon' && index !== undefined && losing === false) 
    if (position !== 'field' && position !== 'cast') {

      // 魔法カラー

      let backgroundColor = '';

      // if (state.registeredCard[asset].category === 'magic') {
      //   // backgroundColor = 'backgroundColorMagic';
      //   backgroundColor = ' backgroundImageNone backgroundColorLightGreen';
      // }
      // else {
      //   backgroundColor = '';
      // }

      summonButtonSP =
      <button className={'button1 marginTop0p5 ' + backgroundColor} tabindex='0'
        onClick={ () => viewCardDetailFunction({popupType: 'itemDetailSP', popupLayer: 1, actionBox: 'close'}) } // ちゃんとpropsでpopupLayer受け取ってもいいよ。
        // onClick={ () => {
        //     const body = {
        //       item: {
        //         asset: asset, 
        //         index: index,
        //       },
        //       side: side,
        //       position: position,
        //       actionBox: 'close',
        //     };

        //     const popup = { type: 'itemDetailSP', body: body };
        //     dispatch({ type: 'setStateMultiLayers', keys: ['popup', 1], value: popup });
        // }}
      >
        <img className='size2x2' src={iconDetail} alt='detail' />
      </button>
    }
    else {
      summonButtonSP = null;
    }
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore ">
        <div className='flexColumn alignItemsCenter ' >
          { cardImage }
          { cardName }
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn alignItemsCenter visibleSmallOrLess ">
        { cardImageSP }
        {/* cardNameSP */}
        { summonButtonSP }
      </div>
    </div>
  );
}

// MAGIC INSTRUCTION
function MagicInstruction(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const fontSize = props.fontSize;
  const selectStatus = state.duel.selectStatus;
  const myStatus = state.duel.myStatus;
  let instruction = null;

  if (selectStatus.mode === 'magic') {
    const magic = state.duel.castMagics[selectStatus.magicIndex];
    const route = magic.route[selectStatus.routeIndex];

    if (route.type === 'target') {
      if (route.detail.source === 'field') {
        instruction = <InstructionAnimation text={ words.selectTheTargetOfTheMagic[state.language] } fontSize={ fontSize } />
      }
      else if (route.detail.source === 'cemeteryMyself') {
        instruction = <InstructionAnimation text={ words.selectTheTargetOfTheMagicFromYourCemetery[state.language] } fontSize={ fontSize } />
      }
    }
    else if (route.type === 'cost') {
      if (route.detail.type === 'discardCards') {
        instruction = <InstructionAnimation text={ words.selectTheCardToDiscardToTheCemetery[state.language] } fontSize={ fontSize } />
      }
      else if (route.detail.type === 'excludeCardsFromCemetery') {
        instruction = <InstructionAnimation text={ words.selectTheCardToExcludeFromTheCemetery[state.language] } fontSize={ fontSize } />
      }
      else if (route.detail.type === 'excludeMonstersFromCemetery') {
        instruction = <InstructionAnimation text={ words.selectTheMonsterToExcludeFromTheCemetery[state.language] } fontSize={ fontSize } />
      }
    }
  }
  else if (myStatus === 'waitingToSummon' && selectStatus.mode === 'neutral') {
    if (state.duel.basicInformation.difficultyMode === 'advanced' && state.duel.castMagics.length === 0) {
      instruction = <InstructionAnimation text={ words.selectTheMagicToCastOrTheKnightToSummon[state.language] } fontSize={ fontSize } />
    }
    else {
      instruction = <InstructionAnimation text={ words.selectTheKnightToSummon[state.language] } fontSize={ fontSize } />
    }
  }
  else if (myStatus === 'uncomfirmed' && selectStatus.mode === 'neutral') {
    if (state.duel.basicInformation.difficultyMode === 'advanced' && state.duel.castMagics.length === 0) {
      instruction = <InstructionAnimation text={ words.selectTheMagicToCastOrClickOk[state.language] } fontSize={ fontSize } />
    }
    else {
      instruction = <InstructionAnimation text={ words.clickOk[state.language] } fontSize={ fontSize } />
    }
  }


  return instruction;
}

// INSTRUCTION ANIMATION
function InstructionAnimation(props) {
  const text = props.text;
  const fontSize = props.fontSize;
  const KOMColor = '#b08030';

  const animation = useAnimation(
    [
      { backgroundColor: 'rgba(255,255,255,0.5)' },
      { backgroundColor: 'rgba(225,187,77,0.9)' },
    ],
    {
      duration: 1000,
      iterations: Infinity,
      easing: 'ease-in-out',
    }
  );

  useEffect(() => {
    animation.play();
  }, []);


  return (
    <button
      ref={animation}
      style={{
        border: `1px solid ${KOMColor}`,
        borderRadius: '0.5em',
        padding: '0.5em',
        backgroundColor: 'transparent',
        whiteSpace: 'pre-wrap',
        fontSize: fontSize,
      }}
      onClick={ () => {
        animation.cancel();
      }}
    >
      { text }
    </button>
  );
}

// SELECT CONTROL BUTTON
function SelectControlButton(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const selectStatus = state.duel.selectStatus;

  let selectControlBox = null;
  let selectControlButton = null;

  if (selectStatus.mode === 'magic') {
    const magic = state.duel.castMagics[selectStatus.magicIndex];
    const route = magic.route[selectStatus.routeIndex];
    const side = state.duel.basicInformation.side;

    if (route.type === 'target') {
      if (route.detail.source === 'field') {
        selectControlButton =
        <div className='flexRow justifyContentCenter alignItemsCenter ' >
          <button className='button2'
            onClick={ () => {
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics', selectStatus.magicIndex, 'targets', route.index, route.key, 'side'], value: 'self'});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics', side, selectStatus.magicIndex, 'targets', route.index, route.key, 'side'], value: 'self'});

              // ルーティング

              if (selectStatus.routeIndex === magic.route.length - 1) {
                // 魔法モードを抜けニュートラル
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus'], value: { mode: 'neutral' }});
              }
              else {
                // 魔法モード継続。ルート1つ進む。
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus', 'routeIndex'], value: selectStatus.routeIndex + 1});
              }
            }}
          >
            { words.self[state.language] }
          </button>
          <button className='button2'
            onClick={ () => {
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'castMagics', selectStatus.magicIndex, 'targets', route.index, route.key, 'side'], value: 'opponent'});
              dispatch({type: 'setStateMultiLayers', keys: ['duel', 'magics', side, selectStatus.magicIndex, 'targets', route.index, route.key, 'side'], value: 'opponent'});

              // ルーティング

              if (selectStatus.routeIndex === magic.route.length - 1) {
                // 魔法モードを抜けニュートラル
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus'], value: { mode: 'neutral' }});
              }
              else {
                // 魔法モード継続。ルート1つ進む。
                dispatch({type: 'setStateMultiLayers', keys: ['duel', 'selectStatus', 'routeIndex'], value: selectStatus.routeIndex + 1});
              }
            }}
          >
            { words.opponent[state.language] }
          </button>
        </div>

        selectControlBox =
        <div>
          {/* PC */}
          <div className="visibleMiddleOrMore">
            <div className='popupBackgroundMultiLayer' style={{ '--popupLayer': props.layer }}>
              <button className='closePopupMultiLayer' style={{ '--popupLayer': props.layer }}
                onClick={ () => handleClickCancelMagic(state, dispatch, 0) }
              />
              <div className='popupMultiLayer' style={{ '--popupLayer': props.layer }}>
                <button className='topRightClose font2 focusEffect01' tabindex='0'
                  onClick={ () => handleClickCancelMagic(state, dispatch, 0) } 
                >
                  ×
                </button>
                { selectControlButton }
              </div>
            </div>
          </div>
          {/* SP */}
          <div className="visibleSmallOrLess">
            <div className='popupBackgroundMultiLayer' style={{ '--popupLayer': props.layer }}>
              <button className='closePopupMultiLayer' style={{ '--popupLayer': props.layer }}
                onClick={ () => handleClickCancelMagic(state, dispatch, 0) }
              />
              <div className='popupMultiLayerSmallScreen ' style={{ '--popupLayer': props.layer }}>
                <button className='topRightClose font2 focusEffect01' tabindex='0'
                  onClick={ () => handleClickCancelMagic(state, dispatch, 0) } 
                >
                  ×
                </button>
                { selectControlButton }
              </div>
            </div>
          </div>
        </div>
      }
    }
  }

  return (
    <div>
      { selectControlBox }
    </div>
  );
}

// コレクションワード獲得表示
function CollectibleWordShowcase({ faces }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index >= faces.length) {
      return undefined;
    }

    const timer = setTimeout(() => {
      setIndex(currentIndex => currentIndex + 1);
    }, 1500);

    return () => clearTimeout(timer);
  }, [index, faces.length]);

  if (index >= faces.length) {
    return null;
  }

  return (
    <CollectibleWordItem
      key={index}
      face={faces[index]}
    />
  );
}

function CollectibleWordItem({ face }) {
  const animation = useAnimation(
    [
      { opacity: 0, transform: "translate(-50%, -1.2rem) scale(0.6)" },
      { opacity: 1, transform: "translate(-50%, 0) scale(1.12)", offset: 0.18 },
      { opacity: 1, transform: "translate(-50%, 0) scale(1)", offset: 0.32 },
      { opacity: 1, transform: "translate(-50%, 0) scale(1)", offset: 0.82 },
      { opacity: 0, transform: "translate(-50%, -0.6rem) scale(0.92)" },
    ],
    {
      duration: 1500,
      easing: "ease-out",
      fill: "forwards",
    }
  );

  useEffect(() => {
    animation.play();
  }, []);

  return (
    <div
      ref={animation}
      style={{
        position: "fixed",
        top: "0.75rem",
        left: "50%",
        zIndex: 300,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "2.8rem",
          padding: "0.6rem 1.8rem",
          borderRadius: "9999px",
          border: "2px solid rgba(255,255,255,0.9)",
          background: "linear-gradient(135deg, rgba(255,214,128,0.96), rgba(255,138,176,0.96))",
          boxShadow: "0 0.4rem 1.2rem rgba(0,0,0,0.35)",
          color: "#3a2400",
          whiteSpace: "nowrap",
        }}
      >
        <span
          style={{
            fontSize: "1.85rem",
            fontWeight: "bold",
            lineHeight: 1.1,
            textShadow: "0 1px 2px rgba(255,255,255,0.5)",
            letterSpacing: "0.02em",
          }}
        >
          { face }
        </span>
      </div>
    </div>
  );
}

// YOU WIN
function YouWin() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const parts = [];
  // const animations = [];

  parts[0] = <YouWinWord />

  if (state.animation.youWinMona === 'visible') {
    for (let i = 1; i <= 15; i++) {
      parts[i] = <YouWinMona />
    }
  }

  return (
    <button className='backgroundColorTransparent borderNone' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'invisible' }); } } >
      { parts }
    </button>
  );
}

// YOU WIN WORD
function YouWinWord() {
  const animation = useAnimation(
    [
      { width: "0%", height: "0%", transform: "translate(-50%,-50%) rotate(0deg)" },
      { width: "50%", height: "10%", transform: "translate(-50%,-50%) rotate(360deg)" },
    ],
    {
      duration: 1000,
      iterations: 3,
      easing: "ease-in-out",
    }
  );

  useEffect(() => {
    animation.play();
  }, []);

  return (
      <div
        ref={animation}
        style={{
          position: "absolute",
          border: "none",
          // border: "2px solid black",
          backgroundColor: "transparent",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          zIndex: "150",
        }}
      >
        <img className='widthMax heightMax' src={logoWin} alt='win' />
      </div>
  );
}

// YOU WIN MONA
function YouWinMona(props) {
  const style = {
    position: "absolute",
    backgroundColor: "transparent",
    top: "50%",
    left: "50%",
    width: "10px",
    height: "10px",
    // border: "1px solid orange",
    // borderRadius: "50%",
    transform: "translate(-50%,-50%)",
    zIndex: "150",
  }

  const angle = 360 * Math.random();
  const dist = 100 + 100 * Math.random();
  const size = 0.5 + Math.random() * 4;
  // const hue = 30 + Math.random() * 25;
  // dot.style.backgroundColor = `hsl(${hue}, 90%, 60%)`;

  const hasBlendmode = Math.random() > 0.5;
  const hasBlur = Math.random() > 0.5;

  if (hasBlendmode) {
    style.mixBlendMode = "add";
  }

  if (hasBlur) {
    style.filter = `blur(${Math.random() * 20}px)`;
  }

  const animation = useAnimation(
    [
      {
        transform: `rotate(${angle}deg) translateX(0px) scale(${size})`,
        opacity: 0.8
      },
      {
        transform: `rotate(${angle}deg) translateX(${ dist * 0.8 }px) scale(${size})`,
        opacity: 0.8, offset: 0.8
      },
      {
        transform: `rotate(${angle}deg) translateX(${dist}px) scale(${size})`,
        opacity: 0
      }
    ],
    {
      duration: 2000 * Math.random(),
      iterations: Infinity,
      fill: "forwards"
    }
  );

  useEffect(() => {
    animation.play();
  }, []);

  return (
      <img ref={ animation } style={ style } src={monaFavicon} alt='mona' />
  );
}

// YOU LOSE
function YouLose() {
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const parts = [];
  //const animations = [];

  for (let i = 0; i <= 0; i++) {
    parts[i] = <YouLoseWord />
  }

  return (
    <button className='backgroundColorTransparent borderNone' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'invisible' }); } } >
      { parts }
    </button>
  );
}

// YOU LOSE WORD
function YouLoseWord() {
  const animation = useAnimation(
    [
      { width: "0%", height: "0%", transform: "translate(-50%,-50%) rotate(0deg)" },
      { width: "50%", height: "10%", transform: "translate(-50%,-50%) rotate(360deg)" },
    ],
    {
      duration: 1000,
      iterations: 3,
      easing: "ease-in-out",
    }
  );

  useEffect(() => {
    animation.play();
  }, []);

  return (
      <div
        ref={animation}
        style={{
          position: "absolute",
          border: "none",
          // border: "2px solid black",
          backgroundColor: "transparent",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          zIndex: "150",
        }}
      >
        <img className='widthMax heightMax' src={logoLose} alt='lose' />
      </div>
  );
}

// DRAW
function Draw() {
  const animationWord = useAnimation(
    [
      { width: "0%", height: "0%", transform: "translate(-50%,-50%) rotate(0deg)" },
      { width: "50%", height: "10%", transform: "translate(-50%,-50%) rotate(360deg)" },
    ],
    {
      duration: 1000,
      iterations: 3,
      easing: "ease-in-out",
    }
  );

  const animationWire = useAnimation(
    [
      { transform: "rotate(0deg)", borderRadius: "1rem" },
      { transform: "rotate(360deg)", borderRadius: "50%" },
      { transform: "rotate(720deg)", borderRadius: "1rem" },
    ],
    {
      duration: 1000,
      iterations: Infinity,
      easing: "ease-in-out",
    }
  );

  useEffect(() => {
    animationWire.play();
    animationWord.play();
  }, []);

  return (
    <div>
      <div className='z150Center'>
        <div
          ref={animationWire}
          style={{
            border: "solid 0.1rem #135569",
            height: "6rem",
            width: "6rem",
            margin: "2rem 0 2rem 2rem",
          }}
        />
      </div>
      <div
        ref={animationWord}
        style={{
          position: "absolute",
          border: "none",
          // border: "2px solid black",
          backgroundColor: "transparent",
          top: "50%",
          left: "50%",
          width: "0%",
          height: "0%",
          transform: "translate(-50%,-50%)",
          zIndex: "160",
        }}
      >
        <img className='widthMax heightMax' src={logoDraw} alt='draw' />
      </div>
    </div>
  );
}

// DUEL UP 
function DuelUp() {
  const parts = [];
  // const animations = [];

  parts[0] = <DuelUpWord />

  // for (let i = 1; i <= 20; i++) {
  //   parts[i] = <YouWinMona />
  // }

  return (
    <div className=''>
      { parts }
    </div>
  );
}

// DUEL UP WORD
function DuelUpWord() {
  const animation = useAnimation(
    [
      { width: "0%", height: "0%", transform: "translate(-50%,-50%) rotate(0deg)" },
      { width: "50%", height: "10%", transform: "translate(-50%,-50%) rotate(360deg)", offset: 0.6 },
      { width: "50%", height: "10%", transform: "translate(-50%,-50%) rotate(360deg)" },
    ],
    {
      duration: 6000,
      iterations: 1,
      easing: "ease-in-out",
      fill: "none",
    }
  );

  useEffect(() => {
    animation.play();
  }, []);

  return (
      <div
        ref={animation}
        style={{
          position: "absolute",
          border: "none",
          // border: "2px solid black",
          backgroundColor: "transparent",
          top: "50%",
          left: "50%",
          width: "0%",
          height: "0%",
          transform: "translate(-50%,-50%)",
          zIndex: "190",
        }}
      >
        <img className='widthMax heightMax' src={logoTheEnd} alt='the end' />
      </div>
  );
}

// SUMMON EFFECT
function SummonEffect() {
  const summonEffect = <div className='summonEffect' />;

  return (
    <div>
      { summonEffect }
    </div>
  );
}

// BLIND
function Blind(props) {
  const blind = <div className={'blind blind' + props.direction} />;

  return (
    <div>
      { blind }
    </div>
  );
}

// BULLET HOLES
function BulletHoles(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const side = props.side;
  const device = props.device;
  let amountOfBullet;

  if (device === 'SP') {
    amountOfBullet = 11;
  }
  else {
    amountOfBullet = 13;
  }

  useEffect(() => {
    const interval = setInterval( () => {
      const length = state.knightBoxEffectPieces[side].length;

      if (length >= amountOfBullet) {
        clearInterval(interval);
      }
      else {
        const x = Math.random() * 90 + 5;
        const y = Math.random() * 90 + 5;

        dispatch({type: 'setStateMultiLayers', keys: ['knightBoxEffectPieces', side, length], value: { x, y }});
      }
    }, 200); 

    const clearBullets = setTimeout( () => {
      dispatch({type: 'setStateMultiLayers', keys: ['knightBoxEffectPieces', side], value: []});
    }, 10000);

    return () => {
      dispatch({type: 'setStateMultiLayers', keys: ['knightBoxEffectPieces', side], value: []});
      clearTimeout(clearBullets);
      clearInterval(interval);
    };
  }, []);

  const bullets = state.knightBoxEffectPieces[side].map( bullet => <BulletHole x={bullet.x} y={bullet.y} /> );

  return (
    <div className='backgroundColorTransparent borderNone pointerEventsNone' >
      { bullets }
    </div>
  );
}

// BULLET HOLE
function BulletHole(props) {
  const x = props.x;
  const y = props.y;

  const style = {
    position: 'absolute',
    width: '10em',
    height: '10em',
    border: 'none',
    // borderRadius: '50%',
    backgroundColor: 'transparent',
    top: `${y}%`,
    left: `${x}%`,
    transform: 'translate(-50%, -50%)',
    zIndex: "100",
  };

  return (
    <img style={style} src={imageBulletHole01} alt='bullet hole' />

    // <button style={style} onClick={ () => { /* dispatch({ type: 'setStateMultiLayers', keys: ['animation', 'youWinMona'], value: 'invisible' }); */ } } >
    //   <img className='' src={imageBulletHole01} />
    // </button>
  );
}

// SHARE
function Share(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const record = props.record;
  const thisRound = record.result[record.round];
  const textAreaRef = useRef(null);

  const battleStory =
  <div className='flexColumn alignItemsCenter borderKOM padding1'>
    <div className='margin0p5'>
      {words.story[state.language]}
    </div>
    <div className='flexRow justifyContentCenter'>
      <button className='button1 margin1' tabIndex='0'
        onClick={ () => {
          copyDuelHistoryStoryToClipboard({
            dispatch,
            language: state.language,
            registeredCard: state.registeredCard,
            thisRound,
            textAreaRef,
          });
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy story' />
      </button>
      <button className='button1 margin1' tabIndex='0'
        onClick={ () => {
          downloadDuelHistoryStoryImage({
            dispatch,
            language: state.language,
            registeredCard: state.registeredCard,
            thisRound,
          });
        }}
      >
        <img className='size2x2' src={iconDownload} alt='download story' />
      </button>
    </div>
  </div>;

  const knightBoxesImage =
  <div className='flexColumn alignItemsCenter borderKOM padding1'>
    <div className='margin0p5'>
      {words.knightAndMagic[state.language]}
    </div>
    <div className='flexRow justifyContentCenter'>
      <button className='button1 margin1' tabIndex='0'
        onClick={ () => {
          copyDuelHistoryKnightBoxesToClipboard({
            dispatch,
            language: state.language,
            record,
            registeredCard: state.registeredCard,
            round: record.round,
            textAreaRef,
          });
        }}
      >
        <img className='size2x2' src={iconCopy} alt='copy knight boxes' />
      </button>
      <button className='button1 margin1' tabIndex='0'
        onClick={ () => {
          downloadDuelHistoryKnightBoxesImage({
            dispatch,
            language: state.language,
            record,
            registeredCard: state.registeredCard,
            round: record.round,
          });
        }}
      >
        <img className='size2x2' src={iconDownload} alt='download knight boxes' />
      </button>
    </div>
  </div>;

  return (
    <div className='flexColumn alignItemsCenter padding1'>
      {/* PC */}
      <div className='visibleMiddleOrMore flexRow'>
        <div className='margin1'>
          { battleStory }
        </div>
        <div className='margin1'>
          { knightBoxesImage }
        </div>
      </div>
      {/* SP */}
      <div className='visibleSmallOrLess flexColumn'>
        <div className='margin1'>
          { battleStory }
        </div>
        <div className='margin1'>
          { knightBoxesImage }
        </div>
      </div>
    </div>
  );
}

export {
  Duel,
  DeckOnDuelSP,
  DuelSettingsPopup,
}
